<template>
  <Layout>
    <div class="personal-center-container">
      <!-- 用户信息 + 会员信息合并卡片（VIP 区仅报名管家显示） -->
      <div :class="['user-info-card', { 'has-vip': appType === 1 }]">
        <div class="user-info-main">
          <div class="user-avatar-wrapper">
            <img
              v-if="userInfo.avatar"
              :src="userInfo.avatar"
              class="user-avatar"
              alt="头像"
            />
            <div v-else class="user-avatar user-avatar-default">
              <i class="el-icon-user-solid"></i>
            </div>
            <span
              v-if="userInfo.authStatus === 3"
              class="user-auth-badge"
              title="已认证"
            >
              <i class="el-icon-check"></i>
            </span>
          </div>
          <div class="user-info-detail">
            <div class="user-nickname">
              {{ userInfo.nickname || "未设置昵称" }}
            </div>
            <!-- 认证徽标（仅报名管家）：商户流程与平台认证互斥，至多显示一个 -->
            <div
              v-if="appType === 1 && authBadge"
              :class="[
                'auth-badge',
                'auth-badge--' + authBadge.variant,
                { 'is-clickable': authBadgeClickable },
              ]"
              :style="
                authBadge.background
                  ? { background: authBadge.background }
                  : null
              "
              @click="handleAuthBadgeClick"
            >
              <span>{{ authBadge.text }}</span>
              <img
                v-if="authBadge.icon"
                class="auth-badge-icon"
                :src="authBadge.icon"
                alt=""
              />
            </div>
            <!-- 接龙加加：保持原有简单认证状态展示 -->
            <div
              v-else-if="appType === 0"
              class="user-auth-status"
              :class="getUserAuthStatusClass(userInfo.authStatus)"
            >
              <i :class="getUserAuthStatusIcon(userInfo.authStatus)"></i>
              <span>{{ getUserAuthStatusText(userInfo.authStatus) }}</span>
            </div>
          </div>

          <!-- 右侧组：VIP有效期在上，权益四模块与续费按钮同行对齐 -->
          <div v-if="appType === 1" class="vip-entry-right">
            <div v-if="rightsLevel === 2" class="vip-opened-expire">
              {{
                vipExpireText
                  ? "VIP有效期至：" + vipExpireText
                  : "会员权益生效中"
              }}
            </div>
            <div class="vip-entry-row">
              <div class="vip-inline-benefits">
                <div class="benefit-item">
                  <span class="benefit-main">纯净版</span>
                  <span class="benefit-sub">无广告</span>
                </div>
                <div class="benefit-item">
                  <span class="benefit-main">提升上传限额</span>
                  <span class="benefit-sub">文件、视频</span>
                </div>
                <div class="benefit-item">
                  <span class="benefit-main">10+</span>
                  <span class="benefit-sub">尊享特权</span>
                </div>
                <div class="benefit-item">
                  <span class="benefit-main">20+</span>
                  <span class="benefit-sub">功能特权</span>
                </div>
              </div>
              <el-button class="vip-entry-btn" @click="openVipDialog">{{
                rightsLevel === 2 ? "立即续费" : "立即开通"
              }}</el-button>
            </div>
          </div>
        </div>
      </div>

      <!-- 顶部导航按钮区域 -->
      <div class="nav-button-section">
        <button
          v-for="tab in tabOptions"
          :key="tab.name"
          :class="['nav-btn', currentTable === tab.name ? 'active' : '']"
          @click="handleNavClick(tab.name)"
        >
          {{ tab.label }}
        </button>
      </div>

      <!-- 表格区域 -->
      <div class="table-section">
        <!-- 参与订单表格 -->
        <div class="table-container" v-if="currentTable === 'participate'">
          <div v-if="loading" class="loading">加载中...</div>
          <div v-else-if="participateOrders.length > 0" class="table-wrapper">
            <el-table
              :data="participateOrders"
              :header-cell-style="headerCellStyle"
              style="width: 100%"
            >
              <el-table-column
                prop="orderNo"
                label="订单编号"
                align="center"
                width="180"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.orderNo }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="activityName"
                label="活动名称"
                min-width="160"
                align="left"
              >
                <template slot-scope="scope">
                  <div style="text-align: left">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="scope.row.activityName"
                      placement="top"
                      :open-delay="1000"
                    >
                      <p
                        class="hover-underline"
                        style="
                          color: #1877ff;
                          cursor: pointer;
                          margin-bottom: 0;
                        "
                        @click="viewOrderDetail(scope.row)"
                      >
                        {{ scope.row.activityName }}
                      </p>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="参与时间"
                align="center"
                width="160"
              >
                <template slot-scope="scope">
                  {{ formatDateTime(scope.row.createTime) }}
                </template>
              </el-table-column>
              <el-table-column label="订单状态" align="center" width="100">
                <template slot-scope="scope">
                  <span :class="getOrderStatusClass(scope.row.status)">
                    {{ getOrderStatusText(scope.row.status) }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="amount"
                label="金额"
                align="center"
                width="100"
              >
                <template slot-scope="scope">
                  <span style="color: #ff4d4f; font-weight: bold"
                    >¥{{ scope.row.amount }}</span
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-else class="no-data">
            <img
              src="https://ossfastmake.xlkapp.com//static/gift/none.svg"
              class="no-data-icon"
              alt="none"
            />
            <span class="no-data-text">暂无数据</span>
          </div>
        </div>

        <!-- 收费订单表格 -->
        <div class="table-container" v-if="currentTable === 'paid'">
          <!-- 状态筛选 -->
          <div class="paid-filter-tabs">
            <span
              :class="['filter-tab', paidActiveState === '' ? 'active' : '']"
              @click="
                paidActiveState = '';
                handlePaidActiveStateChange();
              "
              >全部</span
            >
            <span
              :class="['filter-tab', paidActiveState === '1' ? 'active' : '']"
              @click="
                paidActiveState = '1';
                handlePaidActiveStateChange();
              "
              >进行中</span
            >
            <span
              :class="['filter-tab', paidActiveState === '3' ? 'active' : '']"
              @click="
                paidActiveState = '3';
                handlePaidActiveStateChange();
              "
              >未开始</span
            >
            <span
              :class="['filter-tab', paidActiveState === '2' ? 'active' : '']"
              @click="
                paidActiveState = '2';
                handlePaidActiveStateChange();
              "
              >已结束</span
            >
          </div>
          <div v-if="loading" class="loading">加载中...</div>
          <div v-else-if="paidOrders.length > 0" class="table-wrapper">
            <el-table
              :data="paidOrders"
              :header-cell-style="headerCellStyle"
              style="width: 100%"
            >
              <el-table-column
                prop="activity_type_name"
                width="80"
                align="left"
              >
                <template slot="header">
                  <span>类型</span>
                </template>
                <template slot-scope="scope">
                  <div
                    :class="isStatisticsOnly(scope.row) ? 'bmclass' : 'sfclass'"
                    style="text-align: center"
                    v-if="scope.row.activityType == 101"
                  >
                    {{ isStatisticsOnly(scope.row) ? "报名" : "收费报名" }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="activityName" label="标题" align="left">
                <template slot-scope="scope">
                  <div style="text-align: left">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="scope.row.activityName"
                      placement="top"
                      :open-delay="1000"
                    >
                      <p
                        class="hover-underline"
                        style="
                          color: #1877ff;
                          cursor: pointer;
                          margin-bottom: 0;
                        "
                        @click="viewOrderManagement(scope.row)"
                      >
                        {{ scope.row.activityName }}
                      </p>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="80" align="center" label="状态">
                <template slot-scope="scope">
                  <div
                    :class="{
                      nobegin: scope.row.status == 1,
                      alreadyend: scope.row.status == 2,
                      going: scope.row.status == 3,
                    }"
                  >
                    <div v-if="scope.row.status == 1">未开始</div>
                    <div v-if="scope.row.status == 2">已结束</div>
                    <div v-if="scope.row.status == 3">进行中</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="创建时间"
                align="center"
                width="160"
              >
                <template slot-scope="scope">
                  {{ formatDateTime(scope.row.createTime) }}
                </template>
              </el-table-column>
              <el-table-column label="活动有效期" align="center" width="180">
                <template slot-scope="scope">
                  {{
                    scope.row.endTime == "2099-12-31 23:59:59"
                      ? "永久有效"
                      : formatDateTime(scope.row.endTime)
                  }}
                </template>
              </el-table-column>
              <el-table-column
                prop="browse_num"
                label="浏览 | 参与"
                align="center"
                width="100"
              >
                <template slot-scope="scope">
                  <span
                    style="font-size: 14px; font-weight: normal; color: #1877ff"
                    >{{ scope.row.browse_num || 0 }} |{{
                      scope.row.sign_num || 0
                    }}
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-else class="no-data">
            <img
              src="https://ossfastmake.xlkapp.com//static/gift/none.svg"
              class="no-data-icon"
              alt="none"
            />
            <span class="no-data-text">暂无收费订单</span>
          </div>
        </div>

        <!-- 认证管理表格 -->
        <div class="table-container" v-if="currentTable === 'auth'">
          <div class="table-header">
            <h3 class="table-title">认证管理</h3>
          </div>
          <div v-if="loading" class="loading">加载中...</div>
          <div v-else-if="authList.length > 0" class="table-wrapper">
            <table class="data-table">
              <thead>
                <tr>
                  <th>认证类型</th>
                  <th>认证状态</th>
                  <th>提交时间</th>
                  <th>审核时间</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in authList" :key="item.id">
                  <td>{{ item.authType }}</td>
                  <td>
                    <span :class="getAuthStatusClass(item.status)">
                      {{ getAuthStatusText(item.status) }}
                    </span>
                  </td>
                  <td>{{ formatDateTime(item.submitTime) }}</td>
                  <td>
                    {{ item.auditTime ? formatDateTime(item.auditTime) : "-" }}
                  </td>
                  <td>
                    <button
                      v-if="item.status === 0 || item.status === 2"
                      @click="showAuthQRDialog = true"
                      class="btn-submit"
                    >
                      重新认证
                    </button>
                    <button
                      v-else
                      @click="viewAuthDetail(item)"
                      class="btn-view"
                    >
                      查看详情
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="no-data">
            <img
              src="https://ossfastmake.xlkapp.com//static/gift/none.svg"
              class="no-data-icon"
              alt="none"
            />
            <span class="no-data-text">暂无认证记录</span>
          </div>
        </div>

        <!-- 钱包账号表格 -->
        <div class="table-container" v-if="currentTable === 'wallet'">
          <!-- 账户余额信息卡片和提现按钮 -->
          <div class="wallet-header-row">
            <div class="wallet-balance-card">
              <div class="balance-item">
                <span class="balance-label">账户余额（元）</span>
                <span class="balance-value">¥{{ accountBalance || 0 }}</span>
              </div>
              <div class="balance-item">
                <span class="balance-label">可提现金额（元）</span>
                <span class="balance-value"
                  >¥{{ withdrawableAmount || 0 }}</span
                >
              </div>
              <div class="balance-item">
                <span class="balance-label"
                  >待结算金额（元）
                  <i
                    class="el-icon-info info-icon"
                    @click="showPendingBalanceTip"
                  ></i
                ></span>
                <span class="balance-value"
                  >¥{{ pendingSettleAmount || 0 }}
                </span>
              </div>
            </div>
            <!-- 提现按钮 -->
            <div class="withdraw-action" v-if="currentWalletTab !== 'withdraw'">
              <el-button type="primary" @click="handleWithdraw">提现</el-button>
            </div>
          </div>

          <!-- 导航切换 -->
          <div class="wallet-nav-tabs">
            <span
              :class="[
                'wallet-nav-item',
                currentWalletTab === 'pending' ? 'active' : '',
              ]"
              @click="
                currentWalletTab = 'pending';
                handleWalletTabChange();
              "
              >待结算</span
            >
            <span
              :class="[
                'wallet-nav-item',
                currentWalletTab === 'settled' ? 'active' : '',
              ]"
              @click="
                currentWalletTab = 'settled';
                handleWalletTabChange();
              "
              >已结算</span
            >
            <span
              :class="[
                'wallet-nav-item',
                currentWalletTab === 'withdraw' ? 'active' : '',
              ]"
              @click="
                currentWalletTab = 'withdraw';
                handleWalletTabChange();
              "
              >提现记录</span
            >
            <span
              :class="[
                'wallet-nav-item',
                currentWalletTab === 'bill' ? 'active' : '',
              ]"
              @click="
                currentWalletTab = 'bill';
                handleWalletTabChange();
              "
              >我的账单</span
            >
          </div>

          <!-- 表格区域 -->
          <div class="wallet-table-section">
            <!-- 我的账单搜索筛选 -->
            <div v-if="currentWalletTab === 'bill'" class="bill-filter">
              <div class="filter-tabs">
                <span
                  :class="[
                    'filter-tab',
                    billFilterType === 'all' ? 'active' : '',
                  ]"
                  @click="handleBillFilterTypeChange('all')"
                  >全部</span
                >
                <span
                  :class="[
                    'filter-tab',
                    billFilterType === 'income' ? 'active' : '',
                  ]"
                  @click="handleBillFilterTypeChange('income')"
                  >收款</span
                >
                <span
                  :class="[
                    'filter-tab',
                    billFilterType === 'refund' ? 'active' : '',
                  ]"
                  @click="handleBillFilterTypeChange('refund')"
                  >退款</span
                >
                <el-select
                  v-model="billTimeRange"
                  placeholder="全部时间"
                  size="small"
                  style="width: 120px; margin-right: 8px"
                  @change="handleBillTimeRangeChange"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option label="近一个月" value="1"></el-option>
                  <el-option label="近三个月" value="3"></el-option>
                  <el-option label="近六个月" value="6"></el-option>
                  <el-option label="近一年" value="12"></el-option>
                </el-select>
              </div>
              <div class="filter-right">
                <el-input
                  v-model="billSearchKeyword"
                  placeholder="请输入搜索关键词"
                  size="small"
                  style="width: 300px"
                  clearable
                  @keyup.enter.native="handleBillSearch"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="handleBillSearch"
                  ></el-button>
                </el-input>
              </div>
            </div>

            <!-- 待结算列表 -->
            <div
              v-if="currentWalletTab === 'pending'"
              class="wallet-table-wrapper"
            >
              <div v-if="loading" class="loading">加载中...</div>
              <div v-else-if="pendingList.length > 0" class="order-list">
                <div
                  class="order-item"
                  v-for="(item, index) in pendingList"
                  :key="index"
                >
                  <div class="order-header">
                    <span class="order-title">{{ item.activityName }}</span>
                    <span class="order-amount"
                      >+{{ item.actualPayAmount }}元</span
                    >
                  </div>
                  <div class="order-body">
                    <span class="order-subtitle">{{ item.goodName }}</span>
                  </div>
                  <div class="order-footer">
                    <span class="order-time">{{ item.createTime }}</span>
                  </div>
                </div>
              </div>
              <div v-else class="no-data">
                <img
                  src="https://ossfastmake.xlkapp.com//static/gift/none.svg"
                  class="no-data-icon"
                  alt="none"
                />
                <span class="no-data-text">暂无待结算记录</span>
              </div>
            </div>

            <!-- 已结算列表 -->
            <div
              v-if="currentWalletTab === 'settled'"
              class="wallet-table-wrapper"
            >
              <div v-if="loading" class="loading">加载中...</div>
              <div v-else-if="settledList.length > 0" class="order-list">
                <div
                  class="order-item"
                  v-for="(item, index) in settledList"
                  :key="index"
                >
                  <div class="order-header">
                    <span class="order-title">{{ item.activityName }}</span>
                    <span class="order-amount settled"
                      >+{{ item.actualPayAmount }}元</span
                    >
                  </div>
                  <div class="order-body">
                    <span class="order-subtitle">{{ item.goodName }}</span>
                  </div>
                  <div class="order-footer">
                    <span class="order-time">{{ item.createTime }}</span>
                  </div>
                </div>
              </div>
              <div v-else class="no-data">
                <img
                  src="https://ossfastmake.xlkapp.com//static/gift/none.svg"
                  class="no-data-icon"
                  alt="none"
                />
                <span class="no-data-text">暂无已结算记录</span>
              </div>
            </div>

            <!-- 提现记录列表 -->
            <div
              v-if="currentWalletTab === 'withdraw'"
              class="wallet-table-wrapper"
            >
              <div v-if="loading" class="loading">加载中...</div>
              <div v-else-if="withdrawList.length > 0" class="order-list">
                <div
                  class="order-item"
                  v-for="(item, index) in withdrawList"
                  :key="index"
                  @click="handleWithdrawDetailClick(item.id)"
                >
                  <div class="order-header">
                    <span class="order-title">
                      微信提现 - 到{{ item.bankName }}({{
                        (item.bankCardNo || "").replace(/\*|\s/g, "").slice(-4)
                      }})-{{ getWithdrawStatusText(item.withdrawStatus) }}
                    </span>
                    <span class="order-amount"
                      >{{ item.withdrawAmount }}元</span
                    >
                  </div>
                  <div class="order-body">
                    <span class="order-subtitle">{{ item.createTime }}</span>
                  </div>
                </div>
              </div>
              <div v-else class="no-data">
                <img
                  src="https://ossfastmake.xlkapp.com//static/gift/none.svg"
                  class="no-data-icon"
                  alt="none"
                />
                <span class="no-data-text">暂无提现记录</span>
              </div>
            </div>

            <!-- 提现详情抽屉 -->
            <el-drawer
              title="提现详情"
              :visible.sync="withdrawDetailDrawerVisible"
              direction="rtl"
              size="500px"
              :before-close="handleCloseWithdrawDetail"
            >
              <div
                class="withdraw-detail-drawer"
                v-loading="withdrawDetailLoading"
              >
                <!-- 顶部金额区域 -->
                <div class="amount-header">
                  <div class="amount-value">
                    {{ withdrawDetailInfo.actualArrivalAmount || 0 }}
                  </div>
                  <div class="amount-status" :class="withdrawStatusClass">
                    {{ withdrawStatusText }}
                  </div>
                </div>

                <!-- 详情信息表格 -->
                <div class="info-table-section">
                  <table class="info-table">
                    <tbody>
                      <tr class="info-row">
                        <td class="info-label">收款姓名</td>
                        <td class="info-value">
                          {{ withdrawDetailInfo.userName || "-" }}
                        </td>
                      </tr>
                      <tr class="info-row">
                        <td class="info-label">收款账户</td>
                        <td class="info-value">
                          {{ withdrawDetailInfo.bankName || "-" }}（{{
                            (withdrawDetailInfo.bankCardNo || "-").slice(-4)
                          }}）
                        </td>
                      </tr>
                      <tr class="info-row">
                        <td class="info-label">创建时间</td>
                        <td class="info-value">
                          {{ withdrawDetailInfo.createTime || "-" }}
                        </td>
                      </tr>
                      <tr class="info-row">
                        <td class="info-label">提现总金额</td>
                        <td class="info-value">
                          {{ withdrawDetailInfo.withdrawAmount || 0 }}元
                        </td>
                      </tr>
                      <tr class="info-row">
                        <td class="info-label">平台服务费</td>
                        <td class="info-value">
                          -{{ withdrawDetailInfo.serviceFee || 0 }}元
                        </td>
                      </tr>
                      <tr class="info-row">
                        <td class="info-label">实际到账金额</td>
                        <td class="info-value actual-amount">
                          {{ withdrawDetailInfo.actualArrivalAmount || 0 }}元
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- 提现进度 -->
                <div class="progress-section">
                  <div class="progress-title">提现进度</div>
                  <div class="progress-timeline">
                    <div
                      v-for="(step, index) in progressList"
                      :key="index"
                      class="progress-item"
                      :class="{
                        'is-first': index === 0,
                        'is-active': step.status === 2,
                        'is-failed': step.status === 3,
                      }"
                    >
                      <div class="progress-dot">
                        <i
                          v-if="step.status === 3"
                          class="el-icon-close"
                          style="color: #f56c6c; font-size: 18px"
                        ></i>
                        <i
                          v-else-if="step.status === 2"
                          class="el-icon-check"
                          style="color: #1877ff; font-size: 18px"
                        ></i>
                        <i
                          v-else
                          class="el-icon-check"
                          style="color: #999; font-size: 18px"
                        ></i>
                      </div>
                      <div class="progress-content">
                        <div class="progress-text">{{ step.text }}</div>
                        <div v-if="step.time" class="progress-time">
                          {{ step.time }}
                        </div>
                        <div v-if="step.reason" class="progress-reason">
                          {{ step.reason }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-drawer>

            <!-- 账单详情抽屉 -->
            <el-drawer
              title="账单详情"
              :visible.sync="billDetailDrawerVisible"
              direction="rtl"
              size="500px"
              :before-close="handleCloseBillDetail"
            >
              <div class="bill-detail-drawer" v-loading="billDetailLoading">
                <!-- 顶部交易金额区域 -->
                <div class="bill-amount-header">
                  <div class="bill-amount-label">交易金额</div>
                  <div class="bill-amount-value" :class="getBillAmountClass()">
                    {{ getBillAmountText() }}
                  </div>
                </div>

                <!-- 详情信息表格 -->
                <div class="bill-info-table-section">
                  <table class="bill-info-table">
                    <tbody>
                      <tr class="bill-info-row">
                        <td class="bill-info-label">活动名称</td>
                        <td class="bill-info-value">
                          {{ billDetailInfo.activityName || "-" }}
                        </td>
                      </tr>
                      <tr class="bill-info-row">
                        <td class="bill-info-label">付费项</td>
                        <td class="bill-info-value">
                          {{ billDetailInfo.payItem || "-" }}
                        </td>
                      </tr>
                      <tr class="bill-info-row">
                        <td class="bill-info-label">报名者姓名</td>
                        <td class="bill-info-value">
                          {{ billDetailInfo.buyerName || "-" }}
                        </td>
                      </tr>
                      <tr class="bill-info-row">
                        <td class="bill-info-label">付费总金额</td>
                        <td class="bill-info-value">
                          {{ billDetailInfo.totalPayAmount || 0 }}（元）
                        </td>
                      </tr>
                      <tr class="bill-info-row">
                        <td class="bill-info-label">账单类型</td>
                        <td class="bill-info-value">
                          {{ getBillTypeText(billDetailInfo.billType) }}
                        </td>
                      </tr>
                      <tr class="bill-info-row">
                        <td class="bill-info-label">订单编号</td>
                        <td class="bill-info-value">
                          <span>{{ billDetailInfo.orderNo || "-" }}</span>
                          <span
                            class="bill-copy-btn"
                            @click="copyOrderNo(billDetailInfo.orderNo)"
                            >复制</span
                          >
                        </td>
                      </tr>
                      <tr class="bill-info-row">
                        <td class="bill-info-label">下单时间</td>
                        <td class="bill-info-value">
                          {{ billDetailInfo.createTime || "-" }}
                        </td>
                      </tr>
                      <tr class="bill-info-row">
                        <td class="bill-info-label">完成时间</td>
                        <td class="bill-info-value">
                          {{ billDetailInfo.completeTime || "-" }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </el-drawer>

            <!-- 我的账单列表 -->
            <div
              v-if="currentWalletTab === 'bill'"
              class="wallet-table-wrapper"
            >
              <div v-if="loading" class="loading">加载中...</div>
              <div v-else-if="billList.length > 0" class="order-list">
                <div
                  class="order-item"
                  v-for="(item, index) in billList"
                  :key="index"
                  @click="handleBillDetailClick(item.id)"
                >
                  <div class="order-header">
                    <span class="order-title">
                      <span class="type" v-if="item.billType == 1">收款</span>
                      <span class="type" v-if="item.billType == 2">退款</span>
                      -{{
                        truncateText(item.activityName || item.title || "-", 7)
                      }}
                      -{{
                        truncateText(item.buyerName || item.userName || "-", 5)
                      }}
                    </span>
                    <span
                      class="order-amount"
                      :class="item.billType === 1 ? 'income' : 'expense'"
                    >
                      {{ item.billType === 1 ? "+" : "-"
                      }}{{ item.transactionAmount || item.amount || 0 }}元
                    </span>
                  </div>
                  <div class="order-footer">
                    <span class="order-time">{{
                      item.createTime || item.createTime
                    }}</span>
                  </div>
                </div>
              </div>
              <div v-else class="no-data">
                <img
                  src="https://ossfastmake.xlkapp.com//static/gift/none.svg"
                  class="no-data-icon"
                  alt="none"
                />
                <span class="no-data-text">暂无账单记录</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 充值订单表格 -->
        <div class="table-container" v-if="currentTable === 'recharge'">
          <!-- 筛选区域 -->
          <div class="filter-section" style="margin-bottom: 20px">
            <el-select
              v-model="timeRange"
              placeholder="时间筛选"
              size="small"
              style="width: 120px"
              @change="handleFilterChange"
            >
              <el-option label="全部" value="0"></el-option>
              <el-option label="近一个月" value="1"></el-option>
              <el-option label="近三个月" value="2"></el-option>
              <el-option label="近六个月" value="3"></el-option>
              <el-option label="近一年" value="4"></el-option>
            </el-select>
            <el-select
              v-model="orderType"
              placeholder="类型筛选"
              size="small"
              style="width: 100px"
              @change="handleFilterChange"
            >
              <el-option label="全部" value="0"></el-option>
              <el-option label="会员" value="1"></el-option>
              <el-option label="红包" value="2"></el-option>
            </el-select>
            <el-input
              v-model="activityName"
              placeholder="请输入你需要搜索的订单编号、活动名称等"
              size="small"
              style="width: 350px"
              clearable
              @keyup.enter.native="handleFilterChange"
            >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="handleFilterChange"
              ></el-button>
            </el-input>
          </div>

          <div v-if="loading" class="loading">加载中...</div>
          <div v-else-if="rechargeOrders.length > 0" class="table-wrapper">
            <el-table
              :data="rechargeOrders"
              :header-cell-style="headerCellStyle"
              style="width: 100%"
            >
              <el-table-column
                prop="activityName"
                label="名称"
                min-width="150"
                align="left"
              >
                <template slot-scope="scope">
                  <span>{{
                    scope.row.vipPlanId
                      ? scope.row.vipPlanId == 1
                        ? "月卡 VIP 会员"
                        : scope.row.vipPlanId == 2
                        ? "季卡 VIP 会员"
                        : "年卡 VIP 会员"
                      : scope.row.activityName
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="类型" align="center" width="80">
                <template slot-scope="scope">
                  <span v-if="scope.row.orderType == 1">会员</span>
                  <span v-else-if="scope.row.orderType == 2">红包</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="amount"
                label="金额"
                align="center"
                width="100"
              >
                <template slot-scope="scope">
                  <span style="color: #ff4d4f; font-weight: bold"
                    >¥{{ scope.row.amount }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="orderNo"
                label="订单编号"
                align="center"
                width="180"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.orderNo }}</span>
                </template>
              </el-table-column>
              <el-table-column label="有效期" align="center" width="160">
                <template slot-scope="scope">
                  <span v-if="scope.row.vipTimeFrom && scope.row.vipTimeTo">
                    {{ formatDateTime(scope.row.vipTimeFrom) }} 至
                    {{ formatDateTime(scope.row.vipTimeTo) }}
                  </span>
                  <span
                    v-else-if="
                      scope.row.orderType == 2 && scope.row.vipTimeFrom
                    "
                  >
                    {{ formatDateTime(scope.row.vipTimeFrom) }} 至 无限期
                  </span>
                  <span
                    v-else-if="scope.row.orderType == 2 && scope.row.createTime"
                  >
                    {{ formatDateTime(scope.row.createTime) }} 至 无限期
                  </span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="订单时间"
                align="center"
                width="160"
              >
                <template slot-scope="scope">
                  {{ formatDateTime(scope.row.createTime) }}
                </template>
              </el-table-column>
              <el-table-column
                label="更多"
                align="center"
                width="150"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.orderType == 1"
                    type="text"
                    size="small"
                    style="color: #409eff"
                    @click="contactService"
                    >联系客服</el-button
                  >
                  <template v-else-if="scope.row.orderType == 2">
                    <el-button
                      type="text"
                      size="small"
                      style="color: #409eff"
                      @click="viewRedPacketDetail(scope.row)"
                      >查看</el-button
                    >
                    <el-button
                      type="text"
                      size="small"
                      style="color: #f56c6c"
                      @click="refundRedPacket(scope.row)"
                      >退回</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-else class="no-data">
            <img
              src="https://ossfastmake.xlkapp.com//static/gift/none.svg"
              class="no-data-icon"
              alt="none"
            />
            <span class="no-data-text">暂无充值记录</span>
          </div>
        </div>
      </div>

      <!-- 分页 -->
      <!-- 收费订单分页 -->
      <el-pagination
        v-show="paidPage.total && currentTable === 'paid'"
        background
        layout="sizes, prev, pager, next, total"
        :page-sizes="[10, 20, 30, 40]"
        :total="paidPage.total"
        :current-page="paidPage.pageNum"
        :page-size="paidPage.pageSize"
        @size-change="handlePaidSizeChange"
        @current-change="handlePaidPageChange"
        style="text-align: center; margin-top: 20px"
      />

      <!-- 钱包分页（待结算、已结算、提现记录、我的账单） -->
      <el-pagination
        v-if="currentTable === 'wallet' && getWalletPageTotal > 0"
        background
        layout="sizes, prev, pager, next, total"
        :page-sizes="[10, 20, 30, 40]"
        :total="getWalletPageTotal"
        :current-page="getWalletPageCurrent"
        :page-size="getWalletPageSize"
        @size-change="handleWalletSizeChange"
        @current-change="handleWalletPageChange"
        style="text-align: center; margin-top: 20px"
      />

      <!-- 充值订单分页 -->
      <el-pagination
        v-show="rechargePage.total && currentTable === 'recharge'"
        background
        layout="sizes, prev, pager, next, total"
        :page-sizes="[10, 20, 30, 40]"
        :total="rechargePage.total"
        :current-page="rechargePage.pageNum"
        :page-size="rechargePage.pageSize"
        @size-change="handleRechargeSizeChange"
        @current-change="handleRechargePageChange"
        style="text-align: center; margin-top: 20px"
      />

      <!-- 小程序扫码弹窗 -->
      <el-dialog
        :title="qrDialogConfig.title"
        :visible.sync="showQRDialog"
        @close="resetQRDialog"
        :show-close="false"
        width="400px"
        custom-class="qr-code-dialog"
      >
        <span slot="title" class="dialog-title">
          <span class="dialog-title-text">{{ qrDialogConfig.title }}</span>
          <img
            class="custom-close"
            src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
            @click="showQRDialog = false"
            alt="关闭"
            title="关闭"
          />
        </span>
        <div class="refund-qr-container">
          <!-- 客服二维码 -->
          <template v-if="isContactQR">
            <img
              v-if="appid === 'wx1e899bddb256a5ca'"
              src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/lsyJL/jljj_kf_new.png"
              style="width: 200px; height: 200px"
              alt="客服二维码"
            />
            <img
              v-if="appid === 'wx7d8daf6d777947a2'"
              src="https://ossfastmake.xlkapp.com//12jielong/bdJL/bmkfblue.png"
              style="width: 200px; height: 200px"
              alt="客服二维码"
            />
          </template>
          <!-- 小程序二维码 -->
          <template v-else>
            <img
              v-if="appType === 0"
              src="@/assets/images/imageLand/jielong_code.jpg"
              style="width: 260px; height: 260px"
              alt=""
            />
            <img
              v-else
              src="https://ossfastmake.xlkapp.com/mini_code/index_infowx7d8daf6d777947a2_new_pro_4233.png"
              style="width: 260px; height: 260px"
              alt=""
            />
          </template>
          <p class="refund-qr-hint">{{ qrDialogConfig.hint }}</p>
        </div>
      </el-dialog>

      <!-- 红包详情弹窗 -->
      <el-dialog
        :visible.sync="showRedPacketDialog"
        @close="resetRedPacketDialog"
        width="450px"
        class="red-packet-dialog"
        title="详情"
      >
        <div class="red-packet-dialog-content" v-loading="redPacketLoading">
          <div class="red-packet-card">
            <div class="red-packet-header">
              <span class="red-packet-title">{{
                redPacketData.activityName
              }}</span>
            </div>
            <div class="red-packet-divider"></div>
            <div class="red-packet-body">
              <div class="red-packet-item">
                <span class="item-label">已领取金额：</span>
                <span class="item-value"
                  >¥{{ redPacketData.claimedAmount || 0 }}/{{
                    redPacketData.totalAmount || 0
                  }}</span
                >
                <span class="item-link" @click="viewClaimDetail"
                  >查看领取详情</span
                >
              </div>
              <div
                class="red-packet-item"
                v-if="redPacketData.probability || redPacketData.claimRate"
              >
                <span class="item-label">中奖概率：</span>
                <span class="item-value"
                  >{{
                    redPacketData.probability || redPacketData.claimRate
                  }}%</span
                >
              </div>
              <div
                class="red-packet-item"
                v-if="
                  redPacketData.drawCondition || redPacketData.lotteryRuleType
                "
              >
                <span class="item-label">抽奖条件：</span>
                <span class="item-value">{{
                  redPacketData.drawCondition ||
                  (redPacketData.lotteryRuleType === 1
                    ? "每个账号仅允许抽取一次"
                    : "每个账号参与次数与抽奖次数一致")
                }}</span>
              </div>
              <div class="red-packet-item" v-if="redPacketData.createTime">
                <span class="item-label">创建时间：</span>
                <span class="item-value">{{
                  formatDateTime(redPacketData.createTime)
                }}</span>
              </div>
              <div
                class="red-packet-item"
                v-if="redPacketData.packetType || redPacketData.redPacketType"
              >
                <span class="item-label">红包类型：</span>
                <span class="item-value">{{
                  getPacketTypeText(
                    redPacketData.packetType || redPacketData.redPacketType,
                  )
                }}</span>
              </div>
              <div
                class="red-packet-item"
                v-if="
                  redPacketData.startTime || redPacketData.activityStartTime
                "
              >
                <span class="item-label">活动时间：</span>
                <span class="item-value"
                  >{{
                    formatDateTime(
                      redPacketData.startTime ||
                        redPacketData.activityStartTime,
                    )
                  }}
                  -
                  {{
                    (redPacketData.endTime || redPacketData.activityEndTime) ===
                    "2099-12-31 23:59:59"
                      ? "永久"
                      : formatDateTime(
                          redPacketData.endTime ||
                            redPacketData.activityEndTime,
                        )
                  }}</span
                >
              </div>
            </div>
          </div>
          <div class="red-packet-actions">
            <el-button
              type="primary"
              :disabled="!canRefund"
              @click="confirmRefund"
              >退回剩余金额</el-button
            >
          </div>
        </div>
      </el-dialog>

      <!-- 退回红包小程序码弹窗 -->
      <el-dialog
        title="退回红包"
        :visible.sync="showRedPacketQRDialog"
        @close="resetRedPacketQRDialog"
        width="400px"
      >
        <div class="refund-qr-container">
          <img
            v-if="appType === 0"
            src="@/assets/images/imageLand/jielong_code.jpg"
            style="width: 260px; height: 260px"
            alt=""
          />
          <img
            v-else
            src="https://ossfastmake.xlkapp.com//12jielong/bdJL/bmewm.jpg"
            style="width: 260px; height: 260px"
            alt=""
          />
          <p class="refund-qr-hint">请扫码去小程序退回剩余金额</p>
        </div>
      </el-dialog>

      <!-- 查看领取详情弹窗 -->
      <ClaimDetailDialog
        v-model="claimDetailDialogVisible"
        :list="claimDetailList"
        :summary="claimDetailSummary"
      />

      <!-- 待结算金额说明弹窗 -->
      <el-dialog
        :visible.sync="pendingBalanceTipVisible"
        width="500px"
        :show-close="false"
        custom-class="pending-balance-tip-dialog"
      >
        <span slot="title" class="dialog-title">
          <span class="dialog-title-text">待结算金额说明</span>
          <img
            class="custom-close"
            src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
            @click="pendingBalanceTipVisible = false"
            alt="关闭"
            title="关闭"
          />
        </span>
        <div class="pending-balance-tip-content">
          <p class="tip-text">
            待结算收入是指参与者报名收费活动后，尚未结算的每个交易金额，当核销成功或参与者选择确认完成后
            (对于已结束未完成的活动，需平台审核，审核周期为 7
            个工作日，审核通过后)，账单变为已结算，交易金额进入可提现金额，可以提现至您的银行账户。
          </p>
          <div class="tip-action">
            <el-button type="primary" @click="pendingBalanceTipVisible = false"
              >我知道了</el-button
            >
          </div>
        </div>
      </el-dialog>

      <!-- 认证结果/说明弹窗（首次进入个人中心一次性引导，仅报名管家） -->
      <el-dialog
        :visible.sync="authPopVisible"
        width="420px"
        :show-close="false"
        custom-class="auth-pop-dialog"
        @close="resetAuthPop"
      >
        <span slot="title" class="dialog-title">
          <span class="dialog-title-text">{{ authPopTitle }}</span>
          <img
            class="custom-close"
            src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
            @click="authPopVisible = false"
            alt="关闭"
            title="关闭"
          />
        </span>
        <div class="auth-pop-content" v-loading="authPopLoading">
          <!-- 认证成功 -->
          <template v-if="authPopView === 'success'">
            <i class="el-icon-success auth-pop-icon success"></i>
            <p class="auth-pop-text">
              您提交的认证申请已审核通过。即日起，您可正常使用本 APP
              的在线收款及提现功能。
            </p>
            <div class="auth-pop-actions">
              <el-button type="primary" @click="authPopVisible = false"
                >我知道了</el-button
              >
            </div>
          </template>
          <!-- 认证失败 -->
          <template v-else-if="authPopView === 'fail'">
            <i class="el-icon-circle-close auth-pop-icon fail"></i>
            <p class="auth-pop-text">
              很抱歉，您的认证申请暂未通过，请检查以下可能原因后重新提交：<br />1.证件信息模糊<br />2.收款账户信息填写错误<br />3.填写信息不完整
            </p>
            <div class="auth-pop-actions">
              <el-button @click="authPopVisible = false">取消</el-button>
              <el-button type="primary" @click="goAuthFromPop"
                >重新认证</el-button
              >
            </div>
          </template>
          <!-- 认证说明 -->
          <template v-else>
            <p class="auth-pop-text">
              1.认证费用限时全免费（0 元获得认证权益、在线收费和钱包提现）；<br />2.认证权益到期即失效，续期需重新提交资料缴费；<br />3.资料提交后
              1-5 个工作日审核，不通过 30 天内可重交、最多 3 次。
            </p>
            <span class="auth-pop-service" @click="contactAuthCustomerService"
              >联系客服</span
            >
            <div class="auth-pop-actions">
              <el-button @click="authPopVisible = false">取消</el-button>
              <el-button type="primary" @click="goAuthFromPop"
                >去认证</el-button
              >
            </div>
          </template>
        </div>
      </el-dialog>

      <!-- 购买会员弹窗 -->
      <el-dialog
        :visible.sync="vipDialogVisible"
        @close="resetVipDialog"
        width="460px"
        :show-close="false"
        custom-class="vip-buy-dialog"
      >
        <span slot="title" class="dialog-title">
          <span class="dialog-title-text">购买会员</span>
          <i
            class="el-icon-close custom-close"
            @click="vipDialogVisible = false"
            title="关闭"
          ></i>
        </span>
        <div class="vip-buy-content" v-loading="vipPlanLoading">
          <div class="vip-plan-list">
            <div
              v-for="plan in vipPlans"
              :key="plan.id"
              :class="[
                'vip-plan-card',
                { active: vipSelectedPlanId === plan.id },
              ]"
              @click="vipSelectedPlanId = plan.id"
            >
              <div class="plan-name">{{ plan.description }}</div>
              <div class="plan-price">¥{{ plan.originalPrice }}</div>
              <div class="plan-per-month">{{ getVipPerMonthText(plan) }}</div>
            </div>
          </div>
          <div class="vip-phone-row">
            <span class="phone-label">手机号：</span>
            <el-input
              v-model="vipPhone"
              placeholder="请输入手机号"
              maxlength="11"
              @input="vipPhone = vipPhone.replace(/\D/g, '')"
            />
          </div>
          <el-button
            class="vip-buy-btn"
            :loading="vipSubmitting"
            @click="handleVipBuy"
            >立即购买</el-button
          >
        </div>
      </el-dialog>

      <!-- 会员扫码支付弹窗 -->
      <el-dialog
        :visible.sync="vipPayQrcodeVisible"
        @close="closeVipPayDialog"
        width="420px"
        :show-close="false"
        custom-class="vip-pay-qrcode-dialog"
      >
        <span slot="title" class="dialog-title">
          <span class="dialog-title-text">支付</span>
          <i
            class="el-icon-close custom-close"
            @click="vipPayQrcodeVisible = false"
            title="关闭"
          ></i>
        </span>
        <div class="vip-pay-content">
          <div class="pay-relogin-tip">
            <i class="el-icon-warning"></i>
            支付成功后需要退出重新登录
          </div>
          <div class="pay-info-item">
            <span class="info-label">应付金额：</span>
            <span class="info-value amount">¥ {{ vipPayInfo.amount }}</span>
          </div>
          <div class="pay-info-item">
            <span class="info-label">手机号：</span>
            <span class="info-value">{{ vipPayInfo.phone || "-" }}</span>
          </div>
          <div class="pay-info-item">
            <span class="info-label">有效期：</span>
            <span class="info-value">{{ vipPayInfo.expireText || "-" }}</span>
          </div>
          <div class="qrcode-section">
            <div class="wechat-pay-logo">
              <img src="@/assets/images/WeChatpay.svg" alt="微信支付" />
              <span>微信支付</span>
            </div>
            <img class="pay-qrcode" :src="vipPayQrcode" alt="支付二维码" />
            <p class="scan-tip">用微信扫一扫即可付款</p>
          </div>
        </div>
      </el-dialog>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import copyrightConfig from "@/utils/config/changeCopyright.js";
import {
  getCreateList,
  getOrderList,
  getMyInfo,
  getRedPacketDetail,
  getAccountInfo,
  getClaimDetail,
} from "@/utils/api/activity";
import {
  getVipPlanList,
  createVipOrder,
  checkVipPaymentStatus,
} from "@/utils/api/vip";
import {
  getAuthInformation,
  getRealNameAuthInfo,
  logCustomerServiceClick,
} from "@/utils/api/user";
import { resolveAuthBadge, resolveAuthClickAction } from "@/utils/authBadge";
import { customerServiceUrl } from "@/utils/config/commonUrl.js";
import serviceAxios from "@/utils/request";
import ClaimDetailDialog from "@/components/ClaimDetailDialog/ClaimDetailDialog.vue";

export default {
  page: {
    meta: [{ name: "description", content: appConfig.description }],
    title: "个人中心",
  },
  name: "PersonalCenter",
  components: { Layout, ClaimDetailDialog },
  data() {
    return {
      loading: false,
      currentTable: "paid", // 当前显示的表格：participate, paid, auth, wallet, contact
      appid: copyrightConfig.AppID,

      // 导航选项
      tabOptions: [
        { label: "参与订单", name: "participate" },
        { label: "收费订单", name: "paid" },
        { label: "认证管理", name: "auth" },
        { label: "钱包账号", name: "wallet" },
        { label: "充值订单", name: "recharge" },
      ],

      // 用户信息
      userInfo: {
        avatar: "",
        nickname: "",
        authStatus: 0, // 0-未认证, 1-审核中, 2-未通过, 3-已认证（统一 Number 后存储）
        authType: 0, // 1-个人, 2-企业, 3-机构
        merchantStatus: null, // 二级商户状态：1-审核中, 2-待签约, 3-已认证, 4-已驳回；null/0/5/6-非商户流程
        merchantType: null, // 商户类型：1-小微 ... 7-社会组织
      },

      // 用户 ID
      userId: "",

      // 参与订单数据
      participateOrders: [],

      // 收费订单数据
      paidOrders: [],

      // 认证管理数据
      authList: [],

      // 钱包账号数据
      walletAccounts: [],

      // 后台返回的真实字段
      accountBalance: 0, // 账户余额
      withdrawableAmount: 0, // 可提现金额
      pendingSettleAmount: 0, // 待结算金额

      // 钱包当前选中的标签
      currentWalletTab: "pending",

      // 待结算列表
      pendingList: [],

      // 已结算列表
      settledList: [],

      // 提现记录列表
      withdrawList: [],

      // 账单列表
      billList: [],

      // 账单筛选条件
      billFilterType: "all", // all, income, refund
      billTimeRange: "", // 空，1, 3, 6, 12
      billSearchKeyword: "", // 搜索关键词

      // 提现详情抽屉
      withdrawDetailDrawerVisible: false,
      withdrawDetailLoading: false,
      withdrawDetailInfo: {},
      progressList: [],

      // 账单详情抽屉
      billDetailDrawerVisible: false,
      billDetailLoading: false,
      billDetailInfo: {},

      // 待结算金额说明弹窗
      pendingBalanceTipVisible: false,

      // 充值订单数据
      rechargeOrders: [],

      // 各标签页独立分页
      pendingPage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      settledPage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      withdrawPage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      billPage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      rechargePage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      paidPage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },

      // 筛选条件
      timeRange: "",
      orderType: "",
      activityName: "",

      // 收费订单状态筛选
      paidActiveState: "", // ''-全部，'3'-进行中，'1'-未开始，'2'-已结束

      // 扫码弹窗
      showQRDialog: false,
      isContactQR: false, // 是否是客服二维码
      qrDialogOverride: null, // 徽标点击等场景的弹窗配置覆盖（优先于 currentTable 映射）

      // 认证引导弹窗（首次进入个人中心一次性弹出，仅报名管家）
      authPopVisible: false,
      authPopLoading: false,
      authPopView: "info", // success-认证成功 / fail-认证失败 / info-认证说明

      // 红包详情弹窗
      showRedPacketDialog: false,
      redPacketLoading: false,
      redPacketData: {},
      canRefund: false,
      currentPacketId: "",

      // 退回红包小程序码弹窗
      showRedPacketQRDialog: false,

      // 领取详情弹窗
      claimDetailDialogVisible: false,
      claimDetailList: [],
      claimDetailSummary: {},

      // VIP 状态：2-已开通 VIP 会员
      rightsLevel: 0,
      vipExpireTime: "",

      // 购买会员弹窗
      vipDialogVisible: false,
      vipPlanLoading: false,
      vipPlans: [],
      vipSelectedPlanId: null,
      vipPhone: "",
      vipSubmitting: false,

      // 会员扫码支付弹窗
      vipPayQrcodeVisible: false,
      vipPayQrcode: "",
      vipPayInfo: {},
      vipPayTimer: null, // 支付状态自动轮询定时器
    };
  },
  created() {
    this.setPageTitle();
    // 加载用户信息（头像、昵称、认证状态）
    this.loadUserInfo();
    // 默认进入时加载收费订单数据
    this.loadPaidOrders();
  },
  beforeDestroy() {
    // 清理支付状态轮询定时器
    this.stopVipPayPolling();
  },
  computed: {
    headerCellStyle() {
      return {
        background: "#F1F3F8",
        color: "#3A3A3C",
        fontWeight: "bold",
      };
    },
    // 应用类型：0-接龙加加，1-报名管家
    appType() {
      if (copyrightConfig.AppID === "wx7d8daf6d777947a2") {
        return 1; // 报名管家
      }
      return 0; // 接龙加加
    },
    // 认证徽标（仅报名管家使用；判定纯函数见 @/utils/authBadge）
    authBadge() {
      return resolveAuthBadge(this.userInfo);
    },
    // 徽标是否可点击（平台审核中无动作，与小程序一致）
    authBadgeClickable() {
      return resolveAuthClickAction(this.userInfo) !== null;
    },
    // 认证引导弹窗标题
    authPopTitle() {
      const titleMap = {
        success: "认证成功",
        fail: "认证失败",
        info: "认证说明",
      };
      return titleMap[this.authPopView] || "认证说明";
    },
    // VIP 有效期展示文本（兼容时间戳与日期字符串两种返回格式）
    vipExpireText() {
      return this.formatVipExpireTime(this.vipExpireTime);
    },
    // 扫码弹窗配置
    qrDialogConfig() {
      // 徽标点击等场景显式指定的配置优先
      if (this.qrDialogOverride) {
        return this.qrDialogOverride;
      }
      // 如果是客服二维码，直接返回客服配置
      if (this.isContactQR) {
        return {
          title: "联系客服",
          hint: "请扫码联系客服",
        };
      }
      const configMap = {
        participate: {
          title: "参与订单",
          hint: "请扫码去小程序查看参与订单",
        },
        auth: {
          title: "认证管理",
          hint: "请扫码去小程序进行认证",
        },
        wallet: {
          title: "钱包账号",
          hint: "请扫码去小程序进行提现",
        },
      };
      return configMap[this.currentTable] || configMap.participate;
    },
    // 提现状态样式类
    withdrawStatusClass() {
      const classMap = {
        1: "status-pending",
        2: "status-success",
        3: "status-failed",
      };
      return classMap[this.withdrawDetailInfo.withdrawStatus] || "";
    },
    // 提现状态文本
    withdrawStatusText() {
      const statusMap = {
        1: "提现处理中",
        2: "提现成功",
        3: "提现失败",
      };
      return statusMap[this.withdrawDetailInfo.withdrawStatus] || "未知";
    },
    // 获取钱包当前标签页的分页总数
    getWalletPageTotal() {
      const pageMap = {
        pending: this.pendingPage.total,
        settled: this.settledPage.total,
        withdraw: this.withdrawPage.total,
        bill: this.billPage.total,
      };
      return pageMap[this.currentWalletTab] || 0;
    },
    // 获取钱包当前标签页的当前页码
    getWalletPageCurrent() {
      const pageMap = {
        pending: this.pendingPage.pageNum,
        settled: this.settledPage.pageNum,
        withdraw: this.withdrawPage.pageNum,
        bill: this.billPage.pageNum,
      };
      return pageMap[this.currentWalletTab] || 1;
    },
    // 获取钱包当前标签页的每页大小
    getWalletPageSize() {
      const pageMap = {
        pending: this.pendingPage.pageSize,
        settled: this.settledPage.pageSize,
        withdraw: this.withdrawPage.pageSize,
        bill: this.billPage.pageSize,
      };
      return pageMap[this.currentWalletTab] || 10;
    },
  },
  methods: {
    // 获取用户信息（含头像、昵称、认证状态）
    async loadUserInfo() {
      try {
        const { status, data } = await getMyInfo({});
        if (status === 1 && data) {
          this.userId = data.id;
          // 存储到 localStorage（getMyInfo 返回的用户 id 字段是 id，
          // 写 user_id 会把字符串 "undefined" 存进本地，AI 发布页会把它拼进 WS 地址）
          localStorage.setItem("userId", data.id);
          // 兼容多种返回结构获取认证状态
          const authStatus = this.normalizeAuthStatus(data);
          const authType =
            (data.authInformation && data.authInformation.authType) ||
            data.authType ||
            0;
          // rightsLevel 可能是数字或字符串，统一转数字
          this.rightsLevel = Number(data.rightsLevel || 0);
          this.vipExpireTime = data.vipExpireTime || "";
          this.userInfo = {
            ...this.userInfo,
            avatar: data.profilePhoto || "",
            nickname: data.nickname || "",
            authStatus: Number(authStatus) || 0,
            authType: Number(authType) || 0,
          };
          // 认证状态以专用接口为准，成功后覆盖 getMyInfo 里的兜底值
          this.loadAuthInformation();
        }
        return status === 1;
      } catch (error) {
        console.error("获取用户信息失败", error);
        return false;
      }
    },

    // 获取认证状态（专用接口 /login/getAuthInformation）
    async loadAuthInformation() {
      try {
        const res = await getAuthInformation();
        const info = (res && res.data) || {};
        if (info.authStatus !== undefined) {
          this.userInfo = {
            ...this.userInfo,
            authStatus: Number(info.authStatus) || 0,
            authType: Number(info.authType) || 0,
            merchantStatus: info.merchantStatus,
            merchantType: info.merchantType,
          };
          // 首次进入个人中心的一次性认证引导（仅报名管家）
          this.maybeShowAuthPop();
        }
      } catch (error) {
        console.error("获取认证状态失败", error);
      }
    },

    // 首次进入个人中心的一次性认证引导弹窗（本地记忆已弹过，登出不清理）
    maybeShowAuthPop() {
      if (this.appType !== 1) return; // 仅报名管家
      const { authStatus, merchantStatus } = this.userInfo;
      if (Number(authStatus) <= 1) return; // 未认证/审核中不弹
      if (Number(merchantStatus) === 3) return; // 商户已认证不弹
      if (localStorage.getItem("authPromptStatus") === "1") return; // 已弹过
      localStorage.setItem("authPromptStatus", "1");
      this.openAuthPop();
    },

    // 打开认证弹窗并按实名认证状态决定视图（3-成功 / 2-失败 / 其他-说明）
    async openAuthPop() {
      this.authPopVisible = true;
      this.authPopLoading = true;
      try {
        const res = await getRealNameAuthInfo();
        const realNameAuth = (res && res.data && res.data.realNameAuth) || {};
        const status = Number(realNameAuth.authStatus);
        this.authPopView =
          status === 3 ? "success" : status === 2 ? "fail" : "info";
      } catch (error) {
        console.error("获取实名认证信息失败", error);
        this.authPopView = "info"; // 失败默认说明视图
      } finally {
        this.authPopLoading = false;
      }
    },

    // 重置认证弹窗
    resetAuthPop() {
      this.authPopView = "info";
    },

    // 认证弹窗去认证/重新认证：PC 暂无认证流程页面，引导前往小程序
    goAuthFromPop() {
      this.authPopVisible = false;
      this.qrDialogOverride = {
        title: "身份认证",
        hint: "请扫码前往小程序完成认证",
      };
      this.isContactQR = false;
      this.showQRDialog = true;
    },

    // 认证弹窗联系客服：企微客服链接 + 点击埋点（失败静默）
    contactAuthCustomerService() {
      logCustomerServiceClick().catch(() => {});
      if (customerServiceUrl) {
        window.open(customerServiceUrl, "_blank");
      }
    },

    // 认证徽标点击：按状态引导前往小程序（平台审核中无动作，与小程序一致）
    handleAuthBadgeClick() {
      const action = resolveAuthClickAction(this.userInfo);
      if (!action) return;
      const guideMap = {
        merchant: {
          title: "商户认证",
          hint: "请扫码前往小程序查看商户认证进度",
        },
        success: {
          title: "认证信息",
          hint: "请扫码前往小程序查看或变更认证信息",
        },
        choose: { title: "身份认证", hint: "请扫码前往小程序完成认证" },
      };
      this.qrDialogOverride = guideMap[action];
      this.isContactQR = false;
      this.showQRDialog = true;
    },

    // 规范化认证状态字段（兼容 data.authStatus / data.authInformation.authStatus）
    normalizeAuthStatus(data) {
      if (
        data.authInformation &&
        data.authInformation.authStatus !== undefined
      ) {
        return data.authInformation.authStatus;
      }
      if (data.authStatus !== undefined) {
        return data.authStatus;
      }
      return 0;
    },

    // 获取认证状态文本（用户卡片）
    getUserAuthStatusText(status) {
      const map = {
        0: "未认证",
        1: "认证审核中",
        2: "认证未通过",
        3: "已认证",
      };
      return map[status] || "未认证";
    },

    // 获取认证状态样式类（用户卡片）
    getUserAuthStatusClass(status) {
      const map = {
        0: "auth-unverified",
        1: "auth-pending",
        2: "auth-rejected",
        3: "auth-verified",
      };
      return map[status] || "auth-unverified";
    },

    // 获取认证状态图标（用户卡片）
    getUserAuthStatusIcon(status) {
      const map = {
        0: "el-icon-warning-outline",
        1: "el-icon-time",
        2: "el-icon-circle-close",
        3: "el-icon-medal",
      };
      return map[status] || "el-icon-warning-outline";
    },

    // 获取认证状态文本（认证管理表格）
    getAuthStatusText(status) {
      const map = {
        0: "未认证",
        1: "审核中",
        2: "未通过",
        3: "已认证",
      };
      return map[status] || "未知";
    },

    // 获取认证状态样式类（认证管理表格）
    getAuthStatusClass(status) {
      const map = {
        0: "auth-unverified",
        1: "auth-pending",
        2: "auth-rejected",
        3: "auth-verified",
      };
      return map[status] || "auth-unverified";
    },

    // 设置页面标题
    setPageTitle() {
      let suffix = "接龙加加";
      if (copyrightConfig.AppID === "wx7d8daf6d777947a2") {
        suffix = "报名管家";
      }
      document.title = `个人中心 - ${suffix}`;
      console.log(document.title, "document.title");
    },

    // Tab 切换处理
    handleTabClick(tab) {
      this.handleNavClick(tab.name);
    },

    // 导航按钮点击处理
    handleNavClick(name) {
      this.currentTable = name;
      switch (name) {
        case "participate":
          this.loadParticipateOrders();
          // 弹出扫码窗口
          this.$nextTick(() => {
            this.showQRDialog = true;
          });
          break;
        case "paid":
          this.loadPaidOrders();
          break;
        case "auth":
          this.loadAuthList();
          // 弹出扫码窗口
          this.$nextTick(() => {
            this.showQRDialog = true;
          });
          break;
        case "wallet":
          this.loadWalletAccounts();
          break;
        case "recharge":
          this.loadRechargeOrders();
          break;
      }
    },

    // 钱包标签切换
    handleWalletTabChange() {
      if (!this.loading) {
        // 切换标签时重置页码为 1
        const pageMap = {
          pending: this.pendingPage,
          settled: this.settledPage,
          withdraw: this.withdrawPage,
          bill: this.billPage,
        };
        const currentPage = pageMap[this.currentWalletTab];
        if (currentPage) {
          currentPage.pageNum = 1;
        }
        this.loadWalletTabData();
      }
    },

    // 账单筛选类型切换
    handleBillFilterTypeChange(type) {
      this.billFilterType = type;
      this.billPage.pageNum = 1;
      this.loadBillList();
    },

    // 账单时间范围切换
    handleBillTimeRangeChange(value) {
      this.billTimeRange = value;
      this.billPage.pageNum = 1;
      this.loadBillList();
    },

    // 账单搜索
    handleBillSearch() {
      this.billPage.pageNum = 1;
      this.loadBillList();
    },

    // 加载参与订单
    async loadParticipateOrders() {},

    // 是否「仅统计不收费」收费报名（paymentSwitch=2；后端可能返回字符串或下划线字段，宽松判断）
    isStatisticsOnly(item) {
      return item.paymentSwitch == 2 || item.payment_switch == 2;
    },

    // 加载收费订单
    async loadPaidOrders() {
      this.loading = true;
      try {
        // 获取收费报名活动（activity_type = 101）
        const { status, data } = await getCreateList({
          pageSize: this.paidPage.pageSize,
          pageNum: this.paidPage.pageNum,
          activityBigType: "",
          activityType: "101", // 收费报名
          recordType: 1, // 我的发布
          sortType: "",
          activeState: this.paidActiveState,
          isDraft: 0, // 非草稿
          timeRange: "",
          activityName: "",
          startTime: "",
          endTime: "",
        });

        if (status === 1) {
          this.paidPage.total = data.total;
          this.paidOrders = data.list.map((item) => ({
            id: item.id,
            activityTypeName:
              item.paymentSwitch == 2 || item.payment_switch == 2
                ? "报名"
                : "收费报名",
            activityType: item.activity_type,
            paymentSwitch: item.paymentSwitch,
            payment_switch: item.payment_switch,
            activityName: item.name,
            createTime: item.begin_time || item.create_time,
            status: item.active_state,
            startTime: item.begin_time,
            endTime: item.end_time,
            browse_num: item.browse_num || 0,
            sign_num: item.sign_num || 0,
          }));
        } else {
          this.paidOrders = [];
        }
      } catch (error) {
        console.error("加载收费订单失败", error);
        this.paidOrders = [];
      } finally {
        this.loading = false;
      }
    },

    // 加载认证管理
    async loadAuthList() {
      this.loading = true;
      // TODO: 调用 API 获取认证列表
      setTimeout(() => {
        this.authList = [];
        this.loading = false;
      }, 300);
    },

    // 加载钱包账号
    async loadWalletAccounts() {
      console.log("加载钱包账号");
      this.loading = true;
      try {
        // 调用 API 获取账户信息（待结算金额）
        const { pendingSettleAmount, withdrawableAmount, accountBalance } =
          await getAccountInfo();
        this.pendingSettleAmount = pendingSettleAmount;
        this.withdrawableAmount = withdrawableAmount;
        this.accountBalance = accountBalance;

        // 加载当前标签页数据
        this.loadWalletTabData();
      } catch (error) {
        console.error("加载钱包数据失败", error);
      } finally {
        this.loading = false;
      }
    },

    // 加载钱包标签页数据
    loadWalletTabData() {
      switch (this.currentWalletTab) {
        case "pending":
          this.loadPendingList();
          break;
        case "settled":
          this.loadSettledList();
          break;
        case "withdraw":
          this.loadWithdrawList();
          break;
        case "bill":
          this.loadBillList();
          break;
      }
    },

    // 加载待结算列表
    async loadPendingList() {
      this.loading = true;
      try {
        const { status, data } = await serviceAxios.post(
          "/api/ext/order/manager/page",
          {
            pageNum: this.pendingPage.pageNum,
            pageSize: this.pendingPage.pageSize,
            orderStatus: 2, // 待结算
          },
        );
        if (status === 1 && data?.list) {
          this.pendingList = data.list || [];
          this.pendingPage.total = data.total || 0;
        } else {
          this.pendingList = [];
          this.pendingPage.total = 0;
        }
      } catch (error) {
        console.error("加载待结算列表失败", error);
        this.pendingList = [];
        this.pendingPage.total = 0;
      } finally {
        this.loading = false;
      }
    },

    // 加载已结算列表
    async loadSettledList() {
      this.loading = true;
      try {
        const { status, data } = await serviceAxios.post(
          "/api/ext/order/manager/page",
          {
            pageNum: this.settledPage.pageNum,
            pageSize: this.settledPage.pageSize,
            orderStatus: 3, // 已结算
          },
        );
        if (status === 1 && data?.list) {
          this.settledList = data.list || [];
          this.settledPage.total = data.total || 0;
        } else {
          this.settledList = [];
          this.settledPage.total = 0;
        }
      } catch (error) {
        console.error("加载已结算列表失败", error);
        this.settledList = [];
        this.settledPage.total = 0;
      } finally {
        this.loading = false;
      }
    },

    // 加载提现记录列表
    async loadWithdrawList() {
      this.loading = true;
      try {
        const { status, data } = await serviceAxios.post(
          "/api/withdraw/record/page",
          {
            pageNum: this.withdrawPage.pageNum,
            pageSize: this.withdrawPage.pageSize,
          },
        );
        if (status === 1 && data?.records) {
          this.withdrawList = data.records || [];
          this.withdrawPage.total = data.total || 0;
        } else {
          this.withdrawList = [];
          this.withdrawPage.total = 0;
        }
      } catch (error) {
        console.error("加载提现记录失败", error);
        this.withdrawList = [];
        this.withdrawPage.total = 0;
      } finally {
        this.loading = false;
      }
    },

    // 加载账单列表
    async loadBillList() {
      this.loading = true;
      try {
        // 根据筛选类型设置 billType
        let billType = null;
        if (this.billFilterType === "income") {
          billType = 1; // 收款
        } else if (this.billFilterType === "refund") {
          billType = 2; // 退款
        }

        // 根据时间范围设置 beforeMonths
        let beforeMonths = null;
        if (this.billTimeRange) {
          beforeMonths = parseInt(this.billTimeRange);
        }

        const { status, data } = await serviceAxios.post("/api/bill/page", {
          pageNum: this.billPage.pageNum,
          pageSize: this.billPage.pageSize,
          billType: billType,
          beforeMonths: beforeMonths,
          keyword: this.billSearchKeyword || undefined,
        });
        console.log("账单列表接口返回:", data);
        if (status === 1 && data?.records) {
          this.billList = data.records || [];
          this.billPage.total = data.total || 0;
          console.log("账单列表第一条数据:", this.billList[0]);
        } else {
          this.billList = [];
          this.billPage.total = 0;
        }
      } catch (error) {
        console.error("加载账单列表失败", error);
        this.billList = [];
        this.billPage.total = 0;
      } finally {
        this.loading = false;
      }
    },

    // 点击提现记录查看详情
    handleWithdrawDetailClick(id) {
      this.loadWithdrawDetail(id);
    },

    // 加载提现详情
    async loadWithdrawDetail(id) {
      this.withdrawDetailLoading = true;
      this.withdrawDetailDrawerVisible = true;
      try {
        const { status, data } = await serviceAxios.get(
          `/api/withdraw/record/detail/${id}`,
        );
        if (status === 1 && data) {
          this.withdrawDetailInfo = data;
          // 根据状态生成进度列表
          this.progressList = this.getProgressList(data);
        }
      } catch (error) {
        console.error("加载提现详情失败", error);
        this.$message.error("加载提现详情失败");
      } finally {
        this.withdrawDetailLoading = false;
      }
    },

    // 获取进度列表
    getProgressList(data) {
      const createTime = this.formatDateTime(data.createTime);
      if (data.withdrawStatus === 3) {
        // 驳回
        return [
          {
            status: 2,
            text: "提现请求已提交，预计 1-5 个工作日内完成打款",
            time: createTime,
          },
          {
            status: 3,
            text: "提现失败",
            reason: data.failReason || "驳回原因：信息审核未通过",
          },
        ];
      } else if (data.withdrawStatus === 2) {
        // 成功
        return [
          {
            status: 2,
            text: "提现请求已提交，预计 1-5 个工作日内完成打款",
            time: createTime,
          },
          {
            status: 2,
            text: "已打款，银行处理中",
          },
          {
            status: 2,
            text: "已完成提现，具体到账时间请以银行为准",
          },
        ];
      } else {
        // 处理中
        return [
          {
            status: 2,
            text: "提现请求已提交，预计 1-5 个工作日内完成打款",
            time: createTime,
          },
          {
            status: 1,
            text: "已打款，银行处理中",
          },
          {
            status: 1,
            text: "已完成提现，具体到账时间请以银行为准",
          },
        ];
      }
    },

    // 关闭提现详情抽屉
    handleCloseWithdrawDetail() {
      this.withdrawDetailDrawerVisible = false;
      this.withdrawDetailInfo = {};
      this.progressList = [];
    },

    // 点击账单查看详情
    handleBillDetailClick(id) {
      this.loadBillDetail(id);
    },

    // 加载账单详情
    async loadBillDetail(id) {
      this.billDetailLoading = true;
      this.billDetailDrawerVisible = true;
      try {
        const { status, data } = await serviceAxios.get(
          `/api/bill/detail/${id}`,
        );
        if (status === 1 && data) {
          this.billDetailInfo = data;
        }
      } catch (error) {
        console.error("加载账单详情失败", error);
        this.$message.error("加载账单详情失败");
      } finally {
        this.billDetailLoading = false;
      }
    },

    // 关闭账单详情抽屉
    handleCloseBillDetail() {
      this.billDetailDrawerVisible = false;
      this.billDetailInfo = {};
    },

    // 复制订单编号
    copyOrderNo(orderNo) {
      if (!orderNo) {
        this.$message.warning("订单编号为空");
        return;
      }
      // 创建临时 input 元素
      const input = document.createElement("input");
      input.setAttribute("value", orderNo);
      input.setAttribute("readonly", "readonly");
      input.style.position = "absolute";
      input.style.left = "-9999px";
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand("copy");
        this.$message.success("复制成功");
      } catch (err) {
        this.$message.error("复制失败");
      } finally {
        document.body.removeChild(input);
      }
    },

    // 获取账单详情金额文本
    getBillAmountText() {
      const amount = this.billDetailInfo.transactionAmount || 0;
      if (this.billDetailInfo.billType === 1) {
        return `+${amount}`;
      }
      return `-${amount}`;
    },

    // 获取账单详情金额样式类
    getBillAmountClass() {
      return this.billDetailInfo.billType === 1 ? "income" : "expense";
    },

    // 获取提现状态文本
    getWithdrawStatusText(status) {
      const statusMap = {
        1: "提现中",
        2: "已到账",
        3: "已驳回",
      };
      return statusMap[status] || "未知";
    },

    // 获取提现状态样式类
    getWithdrawStatusClass(status) {
      const classMap = {
        0: "status-pending",
        1: "status-completed",
        2: "status-cancelled",
        3: "status-paid",
      };
      return classMap[status] || "";
    },

    // 获取账单类型文本
    getBillTypeText(type) {
      const typeMap = {
        1: "收款",
        2: "退款",
      };
      return typeMap[type] || "-";
    },

    // 显示待结算金额说明弹窗
    showPendingBalanceTip() {
      this.pendingBalanceTipVisible = true;
    },

    // 截断文本
    truncateText(text, length) {
      if (!text) return "";
      return text.length > length ? text.substring(0, length) + "..." : text;
    },

    // 提现
    handleWithdraw() {
      this.currentTable = "wallet";
      this.showQRDialog = true;
    },

    // 加载充值订单
    async loadRechargeOrders() {
      this.loading = true;
      try {
        // 先获取用户 ID
        if (!this.userId) {
          await this.loadUserInfo();
        }
        // 调用 API 获取充值订单
        const { status, data } = await getOrderList({
          pageSize: this.rechargePage.pageSize,
          pageNum: this.rechargePage.pageNum,
          userId: this.userId || localStorage.getItem("userId") || "",
          orderType: this.orderType,
          timeRange: this.timeRange,
          activityName: this.activityName || undefined,
          orderStatus: 1,
        });

        if (status === 1) {
          this.rechargePage.total = data.orders?.total || 0;
          this.rechargeOrders = (data.orders?.list || []).map((item) => ({
            id: item.orderId,
            orderNo: item.orderNo,
            orderType: item.orderType,
            vipPlanId: item.vipPlanId,
            activityName: item.activityName,
            packetId: item.packetId,
            createTime: item.createTime,
            status: item.orderStatus,
            amount: item.actualAmount || item.totalAmount || 0,
            vipTimeFrom: item.vipTimeFrom,
            vipTimeTo: item.vipTimeTo,
          }));
        } else {
          this.rechargeOrders = [];
        }
      } catch (error) {
        console.error("加载充值订单失败", error);
        this.rechargeOrders = [];
      } finally {
        this.loading = false;
      }
    },

    // 格式化时间
    formatDateTime(dateTimeStr) {
      if (!dateTimeStr) return "-";
      return dateTimeStr.replace(/\//g, "-");
    },

    // VIP 截止时间格式化：纯数字视为时间戳（10 位秒级 / 13 位毫秒级）转
    // YYYY-MM-DD HH:mm:ss，其余按日期字符串规范化（/ → -）
    formatVipExpireTime(t) {
      if (!t) return "";
      const raw = String(t);
      if (/^\d{10,13}$/.test(raw)) {
        const num = Number(raw);
        const d = new Date(raw.length === 10 ? num * 1000 : num);
        const p = (n) => String(n).padStart(2, "0");
        return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(
          d.getHours(),
        )}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
      }
      return this.formatDateTime(raw);
    },

    // 筛选条件改变
    handleFilterChange() {
      this.rechargePage.pageNum = 1;
      this.loadRechargeOrders();
    },

    // 获取订单状态文本
    getOrderStatusText(status) {
      const statusMap = {
        0: "已取消",
        1: "待支付",
        2: "已支付",
        3: "已完成",
        4: "已退款",
      };
      return statusMap[status] || "未知";
    },

    // 获取订单状态样式类
    getOrderStatusClass(status) {
      const classMap = {
        0: "status-cancelled",
        1: "status-pending",
        2: "status-paid",
        3: "status-completed",
        4: "status-refunded",
      };
      return classMap[status] || "";
    },

    // 查看订单详情
    viewOrderDetail(item) {
      this.$router.push({
        path: "/orderManagementList",
        query: {
          activityId: item.id,
          activityName: item.activityName,
        },
      });
    },

    // 查看订单管理（收费订单）
    viewOrderManagement(item) {
      this.$router.push({
        path: "/orderManagementList",
        query: {
          activityId: item.id,
          activityName: item.activityName,
        },
      });
    },

    // 浏览活动
    viewActivity(item) {
      this.$router.push({
        path: "/activityDetails",
        query: {
          activityId: item.id,
          activityName: item.activityName,
        },
      });
    },

    // 查看认证详情
    viewAuthDetail(item) {
      console.log("查看认证详情", item);
      // TODO: 跳转到认证详情页面
    },

    // 查看充值详情
    viewRechargeDetail(item) {
      console.log("查看充值详情", item);
      // TODO: 跳转到充值详情页面
    },

    // 设为默认账号
    setDefaultAccount(item) {
      console.log("设为默认账号", item);
      // TODO: 调用 API 设置默认账号
    },

    // 删除账号
    deleteAccount(item) {
      console.log("删除账号", item);
      // TODO: 调用 API 删除账号
    },

    // 隐藏账号号码
    maskAccountNumber(number) {
      if (!number) return "";
      if (number.length > 8) {
        return (
          number.substring(0, 4) + "****" + number.substring(number.length - 4)
        );
      }
      return "****";
    },

    // 查看领取详情
    viewClaimDetail() {
      this.currentPacketId = this.redPacketData.packetId;
      this.claimDetailDialogVisible = true;
      this.getClaimDetailList();
    },

    // 获取领取详情列表
    async getClaimDetailList() {
      this.loading = true;
      try {
        const { status, data } = await getClaimDetail({
          packetId: this.currentPacketId,
          pageNum: 1,
          pageSize: 20,
        });
        if (status === 1 || data) {
          this.claimDetailList = data.claimList || [];
          this.claimDetailSummary = {
            claimedCount: data.claimedCount || 0,
            totalCount: data.totalCount || 0,
            claimedAmount: data.claimedAmount || 0,
            totalAmount: data.totalAmount || 0,
          };
        }
      } catch (error) {
        console.error("获取领取详情失败", error);
      } finally {
        this.loading = false;
      }
    },

    // 联系客服
    contactService() {
      this.isContactQR = true; // 设置是客服二维码
      this.showQRDialog = true;
    },

    // 查看红包详情
    async viewRedPacketDetail(item) {
      if (!item.packetId) {
        this.$message.warning("该红包暂无详情");
        return;
      }
      this.currentPacketId = item.packetId;
      this.showRedPacketDialog = true;
      this.redPacketLoading = true;
      this.canRefund = false; // 先重置为不可退
      try {
        const { status, data } = await getRedPacketDetail({
          packetId: item.packetId,
        });
        console.log("红包详情数据:", data);
        if (status === 1 && data) {
          this.redPacketData = data;
          // 判断是否有剩余金额（已领取金额 < 总金额 说明有剩余）
          const claimed = parseFloat(data.claimedAmount) || 0;
          const total = parseFloat(data.totalAmount) || 0;
          this.canRefund = claimed < total;
          console.log(
            "canRefund:",
            this.canRefund,
            "claimed:",
            claimed,
            "total:",
            total,
          );
        } else {
          this.$message.warning("获取红包详情失败");
        }
      } catch (error) {
        console.error("获取红包详情失败", error);
        this.$message.error("获取红包详情失败");
      } finally {
        this.redPacketLoading = false;
      }
    },

    // 重置红包弹窗
    resetRedPacketDialog() {
      this.showRedPacketDialog = false;
      this.redPacketData = {};
      this.canRefund = false;
      this.currentPacketId = "";
    },

    // 确认退回红包
    confirmRefund() {
      // 判断活动是否结束
      const now = new Date();
      const endTime =
        this.redPacketData.endTime || this.redPacketData.activityEndTime;

      if (endTime && endTime !== "2099-12-31 23:59:59") {
        const endDateTime = new Date(endTime.replace(/\//g, "-"));
        if (now < endDateTime) {
          this.$message.warning("活动尚未结束，无法退回剩余金额，请结束后申请");
          return;
        }
      }

      // 活动已结束，显示小程序码扫码退回
      this.showRedPacketQRDialog = true;
      this.canRefund = false;
    },

    // 重置退回弹窗
    resetRedPacketQRDialog() {
      this.showRedPacketQRDialog = false;
      this.canRefund = false;
    },

    // 获取红包类型文本
    getPacketTypeText(type) {
      return type === 1 || type === 2 ? "拼手气红包" : "固定金额红包";
    },

    // 获取红包状态文本
    getRedPacketStatusText(status) {
      const statusMap = {
        0: "未开始",
        1: "进行中",
        2: "已结束",
        3: "已停用",
      };
      return statusMap[status] || "未知";
    },

    // 获取红包状态样式类
    getRedPacketStatusClass(status) {
      const classMap = {
        0: "status-pending",
        1: "status-going",
        2: "status-ended",
        3: "status-stopped",
      };
      return classMap[status] || "";
    },

    // 退回红包
    async refundRedPacket(item) {
      if (!item.packetId) {
        this.$message.warning("该红包暂无详情");
        return;
      }
      // 先获取红包详情
      try {
        const { status, data } = await getRedPacketDetail({
          packetId: item.packetId,
        });
        if (status !== 1 || !data) {
          this.$message.warning("获取红包详情失败");
          return;
        }
        this.redPacketData = data;
        this.currentPacketId = item.packetId;

        // 判断活动是否结束
        const now = new Date();
        const endTime = data.endTime || data.activityEndTime;

        if (endTime && endTime !== "2099-12-31 23:59:59") {
          const endDateTime = new Date(endTime.replace(/\//g, "-"));
          if (now < endDateTime) {
            this.$message.warning(
              "活动尚未结束，无法退回剩余金额，请结束后申请",
            );
            return;
          }
        }

        // 活动已结束，显示小程序码扫码退回
        this.showRedPacketQRDialog = true;
      } catch (error) {
        console.error("获取红包详情失败", error);
        this.$message.error("获取红包详情失败");
      }
    },

    // 分页处理
    // 收费订单分页
    handlePaidSizeChange(size) {
      this.paidPage.pageSize = size;
      this.paidPage.pageNum = 1;
      this.loadPaidOrders();
    },

    handlePaidPageChange(page) {
      this.paidPage.pageNum = page;
      this.loadPaidOrders();
    },

    // 收费订单状态筛选变化
    handlePaidActiveStateChange() {
      this.paidPage.pageNum = 1;
      this.loadPaidOrders();
    },

    // 钱包分页（待结算、已结算、提现记录、我的账单）
    handleWalletSizeChange(size) {
      const pageMap = {
        pending: this.pendingPage,
        settled: this.settledPage,
        withdraw: this.withdrawPage,
        bill: this.billPage,
      };
      const currentPage = pageMap[this.currentWalletTab];
      if (currentPage) {
        currentPage.pageSize = size;
        currentPage.pageNum = 1;
      }
      this.loadWalletTabData();
    },

    handleWalletPageChange(page) {
      const pageMap = {
        pending: this.pendingPage,
        settled: this.settledPage,
        withdraw: this.withdrawPage,
        bill: this.billPage,
      };
      const currentPage = pageMap[this.currentWalletTab];
      if (currentPage) {
        currentPage.pageNum = page;
      }
      this.loadWalletTabData();
    },

    // 充值订单分页
    handleRechargeSizeChange(size) {
      this.rechargePage.pageSize = size;
      this.rechargePage.pageNum = 1;
      this.loadRechargeOrders();
    },

    handleRechargePageChange(page) {
      this.rechargePage.pageNum = page;
      this.loadRechargeOrders();
    },

    // 重置弹窗
    resetQRDialog() {
      this.showQRDialog = false;
      this.isContactQR = false; // 重置客服标志
      this.qrDialogOverride = null; // 重置配置覆盖
    },

    // ===== 开通会员 =====
    // 打开购买会员弹窗并拉取套餐列表
    openVipDialog() {
      this.vipDialogVisible = true;
      this.loadVipPlans();
    },

    // 加载会员套餐列表（默认选中最后一项，即时长最长的档位）
    async loadVipPlans() {
      this.vipPlanLoading = true;
      try {
        const { status, data } = await getVipPlanList();
        if (status === 1 && Array.isArray(data) && data.length > 0) {
          this.vipPlans = data;
          this.vipSelectedPlanId = data[data.length - 1].id;
        } else {
          this.vipPlans = [];
          this.vipSelectedPlanId = null;
        }
      } catch (error) {
        console.error("加载会员套餐失败", error);
        this.vipPlans = [];
        this.vipSelectedPlanId = null;
      } finally {
        this.vipPlanLoading = false;
      }
    },

    // 套餐折算月均价展示（如 ¥30/30天 → 30.00元/月）
    getVipPerMonthText(plan) {
      const days = plan.durationDays || 30;
      const months = Math.max(1, Math.round(days / 30));
      const perMonth = (Number(plan.originalPrice) || 0) / months;
      return `${perMonth.toFixed(2)}元/月`;
    },

    // 立即购买：校验手机号后创建订单，成功后展示扫码支付
    async handleVipBuy() {
      if (!this.vipSelectedPlanId) {
        this.$message.warning("请选择套餐");
        return;
      }
      if (!this.vipPhone) {
        this.$message.warning("请输入手机号");
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(this.vipPhone)) {
        this.$message.warning("手机号格式错误");
        return;
      }
      const plan = this.vipPlans.find(
        (item) => item.id === this.vipSelectedPlanId,
      );
      this.vipSubmitting = true;
      try {
        const { status, msg, data } = await createVipOrder({
          vipPlanId: this.vipSelectedPlanId,
          phone: this.vipPhone,
        });
        if (status === 1 && data?.qrCodeBase64) {
          this.vipPayQrcode = data.qrCodeBase64;
          this.vipPayInfo = {
            amount:
              data.amount != null
                ? data.amount
                : plan
                ? plan.originalPrice
                : "",
            orderNo: data.orderNo || "",
            phone: this.vipPhone,
            // 有效期展示支付后的截止时间（vipExpireTimeAfterPay）
            expireText: this.formatVipExpireTime(data.vipExpireTimeAfterPay),
          };
          this.vipPayQrcodeVisible = true;
          this.vipDialogVisible = false;
          this.startVipPayPolling();
        } else {
          this.$message.error(msg || "订单创建失败，请重试");
        }
      } catch (error) {
        console.error("创建会员订单失败", error);
        this.$message.error("订单创建失败，请重试");
      } finally {
        this.vipSubmitting = false;
      }
    },

    // 重置购买会员弹窗
    resetVipDialog() {
      this.vipDialogVisible = false;
      this.vipPhone = "";
    },

    // 关闭会员扫码支付弹窗
    closeVipPayDialog() {
      this.stopVipPayPolling();
      this.vipPayQrcodeVisible = false;
      this.vipPayQrcode = "";
      this.vipPayInfo = {};
    },

    // 支付状态自动轮询（弹窗内无「我已支付」按钮，静默轮询直到支付成功或弹窗关闭）
    startVipPayPolling() {
      this.stopVipPayPolling();
      this.vipPayTimer = setInterval(async () => {
        if (!this.vipPayQrcodeVisible || !this.vipPayInfo.orderNo) return;
        try {
          const res = await checkVipPaymentStatus({
            orderNo: this.vipPayInfo.orderNo,
          });
          // 返回结构：{ status, msg, data: { orderNo, orderStatus, orderStatusDesc } }，orderStatus=1 表示已支付
          if (res.data && res.data.orderStatus == 1) {
            this.handleVipPaySuccess();
          }
        } catch (error) {
          // 单次查询失败静默，等待下一轮
        }
      }, 3000);
    },

    // 停止支付状态轮询
    stopVipPayPolling() {
      if (this.vipPayTimer) {
        clearInterval(this.vipPayTimer);
        this.vipPayTimer = null;
      }
    },

    // 会员支付成功：刷新用户信息（支付回调异步，以后端返回为准）
    handleVipPaySuccess() {
      this.$message.success("支付成功！");
      this.closeVipPayDialog();
      this.loadUserInfo();
    },
  },
};
</script>

<style lang="scss" scoped>
.personal-center-container {
  padding: 20px;
  background: #f7f9ff;
  min-height: calc(100vh - 84px);
}

// 用户信息 + 会员信息合并卡片（900px，单行：信息 | 权益模块 | 有效期+按钮）
.user-info-card {
  display: flex;
  width: 900px;
  max-width: 100%;
  padding: 16px 24px;
  margin-bottom: 20px;
  background: #fff;
  border-radius: 8px;

  // 含 VIP 区时（报名管家）：整卡浅橙到白横向渐变
  &.has-vip {
    background: linear-gradient(270deg, #fff0df 0%, #ffffff 100%);
  }

  .user-info-main {
    display: flex;
    align-items: center;
    gap: 20px;
    width: 100%;
  }

  .user-avatar-wrapper {
    position: relative;
    flex-shrink: 0;

    .user-avatar {
      width: 64px;
      height: 64px;
      border-radius: 50%;
      object-fit: cover;
      border: 2px solid #fff;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    }

    .user-avatar-default {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #c6d9f5;
      color: #fff;

      i {
        font-size: 32px;
      }
    }

    .user-auth-badge {
      position: absolute;
      right: -2px;
      bottom: -2px;
      width: 22px;
      height: 22px;
      background: #1bce4a;
      border: 2px solid #fff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 12px;
    }
  }

  .user-info-detail {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .user-nickname {
      font-size: 18px;
      font-weight: 600;
      color: #303133;
      line-height: 1.2;
    }
  }

  // 右侧组：VIP有效期在上，下方为权益模块与按钮的同行区
  .vip-entry-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
    margin-left: auto;
    flex-shrink: 0;
  }

  .vip-opened-expire {
    font-size: 14px;
    font-weight: 600;
    color: #ff9500;
    line-height: 1.4;
  }

  // 权益模块与续费按钮同行对齐
  .vip-entry-row {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  // 权益模块（有效期与按钮之间，模块间距较大）
  .vip-inline-benefits {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px 56px;

    .benefit-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 2px;
    }

    .benefit-main {
      font-size: 15px;
      font-weight: 600;
      color: #333;
      line-height: 1.4;
    }

    .benefit-sub {
      font-size: 12px;
      color: #999;
      line-height: 1.4;
    }
  }

  .vip-entry-btn {
    flex-shrink: 0;
    background: #ff9500;
    border-color: #ff9500;
    color: #fff;
    border-radius: 25px;
    padding: 9px 22px;
    font-weight: 600;

    &:hover,
    &:focus {
      background: #ffa42b;
      border-color: #ffa42b;
      color: #fff;
    }
  }
}

// 认证状态样式（用户卡片 + 认证管理表格共用）
.user-auth-status {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  line-height: 1.5;
  width: fit-content;
}

.auth-unverified {
  background: #f0f2f5;
  color: #909399;
}

.auth-pending {
  background: #fff7e6;
  color: #fa8c16;
}

.auth-rejected {
  background: #fff0f0;
  color: #f56c6c;
}

.auth-verified {
  background: #f6ffed;
  color: #1bce4a;
}

// 认证徽标（报名管家用户卡片，商户/平台互斥胶囊，规格同小程序）
.auth-badge {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  height: 25px;
  padding: 0 10px;
  border-radius: 15px;
  font-size: 13px;
  line-height: 1;
  background: rgba(255, 255, 255, 0.72);
  color: #8c8c8c;
  user-select: none;

  &.is-clickable {
    cursor: pointer;
  }

  .auth-badge-icon {
    width: 14px;
    height: 14px;
    margin-left: 3px;
  }

  // 审核中（平台/商户同款）：白底 + 橙字
  &.auth-badge--authing {
    color: #ffa21e;
  }

  // 个人认证：橙渐变
  &.auth-badge--gr {
    background: linear-gradient(270deg, #f7a337 0%, #ff9509 5%);
    color: #fff;
  }

  // 企业认证：蓝 conic 渐变
  &.auth-badge--qy {
    background: conic-gradient(#0b5aff 91%, #2c6fff);
    color: #fff;
  }

  // 机构认证：绿渐变
  &.auth-badge--jg {
    background: linear-gradient(270deg, #07cf57 0%, #28cd6a 5%);
    color: #fff;
  }

  // 待签约：青渐变（无图标）
  &.auth-badge--dq {
    background: linear-gradient(270deg, #0bbfbc 0%, #1ad4c9 5%);
    color: #fff;
  }

  // 已驳回：红渐变（无图标）
  &.auth-badge--bh {
    background: linear-gradient(270deg, #ff5a4d 0%, #ff7a6b 5%);
    color: #fff;
  }

  // 商户认证成功：默认紫渐变，可被内联底色覆盖（merchantType 1/2/3/5）
  &.auth-badge--sh {
    background: linear-gradient(270deg, #7a4dff 0%, #9b6dff 5%);
    color: #fff;
  }
}

// 导航按钮区域样式
.nav-button-section {
  margin-bottom: 20px;
  display: flex;
  gap: 12px;
  .nav-btn {
    height: 40px;
    padding: 0 20px;
    font-size: 14px;
    color: #1877ff;
    background: #fff;
    border: 1px solid #1877ff;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      color: #1877ff;
    }

    &.active {
      background: #1877ff;
      color: #fff;
      border-color: #1877ff;
    }
  }
}

// 表格区域样式
.table-section {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.table-container {
  .table-header {
    margin-bottom: 16px;
  }

  .table-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin: 0;
  }
}

.table-wrapper {
  overflow-x: auto;
}

// 表格样式
.el-table {
  font-size: 14px;

  th {
    font-weight: bold;
  }

  .cell {
    padding: 8px 0;
  }
}

// 状态样式
.nobegin {
  margin-top: 2px;
  margin-right: 5px;
  margin-left: 15px;
  font-size: 12px;
  line-height: 19px;
  width: 45px;
  height: 19px;
  background: #fff0f0;
  border: 1px solid #feeaea;
  border-radius: 4px;
  color: #f67a7a;
  display: flex;
  justify-content: center;
}

.alreadyend {
  margin-top: 2px;
  margin-right: 5px;
  margin-left: 15px;
  font-size: 12px;
  line-height: 19px;
  width: 45px;
  height: 19px;
  background: #d8d8d8;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  color: white;
  display: flex;
  justify-content: center;
}

.going {
  margin-top: 2px;
  margin-right: 5px;
  margin-left: 15px;
  font-size: 12px;
  line-height: 19px;
  width: 45px;
  height: 19px;
  background: #1bce4a;
  border: 1px solid #1bce4a;
  border-radius: 4px;
  color: white;
  display: flex;
  justify-content: center;
}

.cgclass {
  margin-top: 2px;
  margin-right: 5px;
  margin-left: 15px;
  font-size: 12px;
  line-height: 19px;
  width: 45px;
  height: 19px;
  background: #fea951;
  border: 1px solid #fea951;
  border-radius: 4px;
  color: white;
  display: flex;
  justify-content: center;
}

.jlclass {
  width: 60px;
  height: 20px;
  background: rgba(81, 111, 240, 0.16);
  border: 1px solid rgba(81, 111, 240, 0.11);
  border-radius: 4px;
  color: #516ff0;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dkclass {
  width: 60px;
  height: 20px;
  background: rgba(85, 167, 253, 0.16);
  border: 1px solid rgba(85, 167, 253, 0.11);
  border-radius: 4px;
  color: #1877ff;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  display: flex;
  justify-content: center;
}

.tzclass {
  width: 60px;
  height: 20px;
  background: rgba(27, 206, 74, 0.16);
  border: 1px solid rgba(27, 206, 74, 0.11);
  border-radius: 4px;
  color: #1bce4a;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  display: flex;
  justify-content: center;
}

.hyclass {
  width: 60px;
  height: 20px;
  background: rgba(107, 27, 206, 0.16);
  border: 1px solid rgba(107, 27, 206, 0.11);
  border-radius: 4px;
  color: #6b1bce;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  display: flex;
  justify-content: center;
}

.sfclass {
  width: 60px;
  height: 20px;
  background: #ffede2;
  border-radius: 4px;
  color: #f98849;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.bmclass {
  width: 60px;
  height: 20px;
  background: rgb(33 202 86 / 20%);
  border-radius: 4px;
  color: #29bc7c;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.hover-underline:hover {
  text-decoration: underline;
}

// 订单状态样式
.status-cancelled {
  padding: 4px 8px;
  background: #f5f5f5;
  color: #909399;
  border-radius: 4px;
  font-size: 12px;
}

.status-pending {
  padding: 4px 8px;
  background: #fff0f0;
  color: #f67a7a;
  border-radius: 4px;
  font-size: 12px;
}

.status-paid {
  padding: 4px 8px;
  background: #e6f7ff;
  color: #1877ff;
  border-radius: 4px;
  font-size: 12px;
}

.status-completed {
  padding: 4px 8px;
  background: #f6ffed;
  color: #1bce4a;
  border-radius: 4px;
  font-size: 12px;
}

.status-refunded {
  padding: 4px 8px;
  background: #fff0f0;
  color: #ff4d4f;
  border-radius: 4px;
  font-size: 12px;
}

// 按钮样式
.btn-view {
  padding: 6px 12px;
  background: #409eff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;

  &:hover {
    background: #66b1ff;
  }
}

.btn-submit {
  padding: 6px 12px;
  background: #67c23a;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;

  &:hover {
    background: #85ce61;
  }
}

.btn-set {
  padding: 6px 12px;
  background: #909399;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  margin-right: 8px;

  &:hover {
    background: #a6a9ad;
  }
}

.btn-delete-small {
  padding: 6px 12px;
  background: #f56c6c;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;

  &:hover {
    background: #f78989;
  }
}

// 无数据样式
.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 50px 0;
  color: #888;
}

.no-data-icon {
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
}

.no-data-text {
  font-size: 16px;
}

.loading {
  text-align: center;
  padding: 30px;
  color: #909399;
}

// 红包详情弹窗样式
.red-packet-dialog {
  .el-dialog__header {
    padding: 0;
    border-bottom: none;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog__footer {
    padding: 0;
    border-top: none;
  }
}
// 红包设置弹窗样式
.red-packet-dialog-content {
  padding: 0;
  max-height: 500px;
  overflow-y: auto;
}

.red-packet-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

  .red-packet-header {
    padding: 12px 16px;

    .red-packet-title {
      font-size: 15px;
      font-weight: 600;
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: block;
    }
  }

  .red-packet-divider {
    height: 1px;
    background: #f0f0f0;
    margin: 0 16px;
  }

  .red-packet-body {
    padding: 12px 16px;

    .red-packet-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 8px;
      font-size: 14px;
      line-height: 1.5;

      &:last-child {
        margin-bottom: 0;
      }

      .item-label {
        color: #666;
        flex-shrink: 0;
        width: 84px;
      }

      .item-value {
        color: #333;
        flex: 1;
        word-break: break-all;
      }

      .item-link {
        color: #409eff;
        cursor: pointer;
        margin-left: 8px;
        flex-shrink: 0;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}

.red-packet-actions {
  display: flex;
  justify-content: center;
  padding: 16px 20px;
  margin-top: 16px;

  .el-button {
    width: 200px;
  }
}

// 退回红包二维码弹窗样式
.refund-qr-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;

  .refund-qr-hint {
    margin-top: 16px;
    font-size: 14px;
    color: #666;
    text-align: center;
  }
}

// 小程序扫码弹窗样式
.qr-code-dialog {
  .el-dialog__header {
    padding: 0;
    border-bottom: 1px solid #f0f0f0;
  }

  .el-dialog__body {
    padding: 20px;
  }

  .el-dialog__footer {
    padding: 0;
  }
}

// 购买会员弹窗样式
::v-deep .vip-buy-dialog {
  .el-dialog {
    background: #fff8e8;
    border-radius: 12px;
  }

  .el-dialog__header {
    padding: 16px 24px 14px;
  }

  // 标题居中、深棕色；右上角橙色圆形白×关闭按钮
  .dialog-title .dialog-title-text {
    color: #5d4037;
  }

  .dialog-title .custom-close {
    width: 26px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    border-radius: 50%;
    background: #ff9800;
    color: #fff;
    font-size: 14px;

    &:hover {
      background: #ffa42b;
      opacity: 1;
    }
  }

  .el-dialog__body {
    padding: 24px 28px;
  }
}

.vip-buy-content {
  .vip-plan-list {
    display: flex;
    gap: 14px;
  }

  .vip-plan-card {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 16px 10px;
    text-align: center;
    background: #fff;
    border: 1.5px solid #f9b762;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.2s;
    position: relative;

    // 选中：米黄渐变底
    &.active {
      background: linear-gradient(180deg, #fff1de, #ffdeba);
    }

    .plan-name {
      font-size: 14px;
      color: #333;
    }

    .plan-price {
      margin: 8px 0;
      font-size: 22px;
      font-weight: 700;
      color: #333;
      padding-bottom: 15px;
    }

    // 折算月均价：沉到卡片底部，选中变珊瑚橙白字
    .plan-per-month {
      width: fit-content;
      margin: auto auto 0;
      padding: 2px 0;
      border-radius: 0 0 10px 10px;
      background: #facb8d;
      font-size: 12px;
      color: #4b2e1c;
      line-height: 1.8;
      position: absolute;
      bottom: -1px;
      width: 100%;
      left: 0;
      right: 0;
    }

    &.active .plan-per-month {
      background: #ff7c5e;
      color: #fff;
    }
  }

  .vip-phone-row {
    display: flex;
    align-items: center;
    margin: 22px 0;

    .phone-label {
      flex-shrink: 0;
      font-size: 14px;
      font-weight: 600;
      color: #333;
    }
  }

  .vip-buy-btn {
    width: 100%;
    background: #ff7f50;
    border: none;
    border-radius: 8px;
    padding: 13px 0;
    font-size: 16px;
    font-weight: 600;
    color: #fff;

    &:hover,
    &:focus {
      background: #ff956f;
      color: #fff;
    }
  }
}

// 会员扫码支付弹窗样式
::v-deep .vip-pay-qrcode-dialog {
  .el-dialog__header {
    padding: 0;
    border-bottom: 1px solid #f0f0f0;
  }

  // 标题加高、右上角灰色圆形×关闭按钮（仅本弹窗）
  .dialog-title {
    padding: 14px 20px;

    .custom-close {
      width: 26px;
      height: 26px;
      line-height: 26px;
      text-align: center;
      border-radius: 50%;
      color: #999;
      font-size: 16px;

      &:hover {
        background: #f5f5f5;
        opacity: 1;
      }
    }
  }

  .el-dialog__body {
    padding: 20px;
  }
}

.vip-pay-content {
  .pay-relogin-tip {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 8px;
    padding: 8px 12px;
    border-radius: 4px;
    background: #fdf6ec;
    font-size: 13px;
    color: #ff9900;

    .el-icon-warning {
      font-size: 14px;
    }
  }

  .pay-info-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 4px;
    font-size: 14px;

    .info-label {
      flex-shrink: 0;
      color: #999;
    }

    .info-value {
      color: #333;

      &.amount {
        color: #ff4d4f;
        font-size: 18px;
        font-weight: 700;
      }
    }
  }

  .qrcode-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 8px;

    .wechat-pay-logo {
      display: flex;
      align-items: center;
      gap: 6px;
      margin-bottom: 12px;

      img {
        height: 22px;
      }

      span {
        font-size: 14px;
        color: #333;
      }
    }

    .pay-qrcode {
      width: 150px;
      height: 150px;
      padding: 8px;
      background: #fff;
      object-fit: contain;
    }

    .scan-tip {
      margin: 12px 0 15px;
      font-size: 13px;
      color: #666;
    }
  }
}

// 弹窗标题样式（多个弹窗共用）
.dialog-title {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;

  .dialog-title-text {
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }

  .custom-close {
    width: 30px;
    height: 30px;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.7;
    }
  }
}

// 钱包余额信息卡片和提现按钮一行布局
.wallet-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

// 钱包余额信息卡片样式
.wallet-balance-card {
  display: flex;
  gap: 16px;
  padding: 12px;
  flex: 1;

  .balance-item {
    width: 200px;
    border-radius: 8px;
    padding: 10px 14px;
    display: flex;
    flex-direction: column;
    gap: 4px;

    &:nth-child(1) {
      background: linear-gradient(136deg, #317af7, #84b0fe 98%);
    }

    &:nth-child(2) {
      background: linear-gradient(180deg, #3a41ef, #888cf7);
    }

    &:nth-child(3) {
      background: linear-gradient(90deg, #37b4c8, #4fcde0);
    }

    .balance-label {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.8);
    }

    .balance-value {
      font-size: 18px;
      font-weight: 600;
      color: #fff;
      font-family: "DIN Alternate", "Arial", sans-serif;
      display: flex;
      align-items: center;
      gap: 4px;
    }
  }

  .info-icon {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.8);
    cursor: pointer;
  }
}

// 提现按钮样式
.withdraw-action {
  flex-shrink: 0;
  margin-left: 16px;

  .el-button {
    width: 120px;
    height: 40px;
    background: #1877ff;
    border-color: #1877ff;
  }
}

// 待结算金额说明弹窗样式
.pending-balance-tip-dialog {
  .el-dialog__header {
    padding: 0;
    border-bottom: 1px solid #f0f0f0;
  }

  .el-dialog__body {
    padding: 20px;
  }

  .el-dialog__footer {
    padding: 0;
  }

  .pending-balance-tip-content {
    .tip-text {
      font-size: 14px;
      color: #333;
      line-height: 1.8;
      margin-bottom: 24px;
    }

    .tip-action {
      display: flex;
      justify-content: center;

      .el-button {
        width: 120px;
      }
    }
  }
}

// 认证结果/说明弹窗
.auth-pop-dialog {
  .el-dialog__header {
    padding: 0;
    border-bottom: 1px solid #f0f0f0;
  }

  .el-dialog__body {
    padding: 24px 20px 20px;
  }

  .auth-pop-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 120px;

    .auth-pop-icon {
      font-size: 52px;
      margin-bottom: 12px;

      &.success {
        color: #1bce4a;
      }

      &.fail {
        color: #f56c6c;
      }
    }

    .auth-pop-text {
      font-size: 14px;
      color: #333;
      line-height: 1.8;
      text-align: center;
      margin: 0 0 16px;
    }

    .auth-pop-service {
      font-size: 14px;
      color: #1877ff;
      cursor: pointer;
      margin-bottom: 16px;

      &:hover {
        text-decoration: underline;
      }
    }

    .auth-pop-actions {
      display: flex;
      justify-content: center;
      gap: 12px;

      .el-button {
        min-width: 120px;
        margin: 0;
      }
    }
  }
}

// 钱包导航标签样式
.wallet-nav-tabs {
  display: flex;
  gap: 0;
  border-bottom: 2px solid #f0f0f0;
  margin-bottom: 16px;

  .wallet-nav-item {
    padding: 12px 24px;
    font-size: 14px;
    color: #606266;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    margin-bottom: -2px;
    transition: all 0.3s;

    &:hover {
      color: #409eff;
    }

    &.active {
      color: #409eff;
      border-bottom-color: #409eff;
      font-weight: 600;
    }
  }
}

// 收费订单筛选标签样式
.paid-filter-tabs {
  display: flex;
  gap: 0;
  border-bottom: 2px solid #f0f0f0;
  margin-bottom: 16px;

  .filter-tab {
    padding: 12px 24px;
    font-size: 14px;
    color: #606266;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    margin-bottom: -2px;
    transition: all 0.3s;

    &:hover {
      color: #409eff;
    }

    &.active {
      color: #409eff;
      border-bottom-color: #409eff;
      font-weight: 600;
    }
  }
}

// 钱包表格区域样式
.wallet-table-section {
  min-height: 300px;
}

// 账单筛选区域样式
.bill-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  gap: 12px;

  .filter-tabs {
    display: flex;
    gap: 8px;

    .filter-tab {
      padding: 6px 16px;
      font-size: 14px;
      color: #606266;
      background: #f5f7fa;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        background: #ecf5ff;
        color: #409eff;
      }

      &.active {
        background: #409eff;
        color: #fff;
      }
    }
  }

  .filter-right {
    display: flex;
    align-items: center;
  }

  .bill-search-btn {
    background: #1877ff !important;
    border-color: #1877ff !important;
    color: #fff !important;

    &:hover {
      background: #409eff !important;
      border-color: #409eff !important;
    }

    .el-icon-search {
      color: #fff;
    }
  }
}

.wallet-table-wrapper {
  .table-wrapper {
    border: 1px solid #ebeef5;
    border-radius: 8px;
    overflow: hidden;
  }
}

// 订单列表样式
.order-list {
  .order-item {
    padding: 8px 16px;
    border-bottom: 1px solid #f0f0f0;
    transition: background-color 0.3s;

    &:hover {
      background-color: #fafafa;
    }

    .order-header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .order-title {
        font-size: 14px;
        color: #333;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 12px;
        line-height: 1.4;

        .type {
          font-weight: bold;
        }
      }

      .order-amount {
        font-size: 16px;
        font-weight: 500;
        color: #ff4d4f;
        flex-shrink: 0;
        white-space: nowrap;

        &.income {
          color: #ff4d13;
        }

        &.expense {
          color: #666666;
        }

        &.settled {
          color: #1bce4a;
        }
      }
    }

    .order-body {
      .order-subtitle {
        font-size: 12px;
        color: #666;
      }
    }

    .order-footer {
      .order-time {
        font-size: 12px;
        color: #999;
      }
    }
  }
}

// 提现详情抽屉样式
.withdraw-detail-drawer {
  padding: 0;

  .amount-header {
    text-align: center;
    padding: 0 20px 30px;
    border-bottom: 1px solid #ebeef5;

    .amount-value {
      font-size: 36px;
      font-weight: 600;
      color: #333;
      font-family: "DIN Alternate", "Arial", sans-serif;
      margin-bottom: 8px;
    }

    .amount-status {
      font-size: 14px;
      color: #303133;
    }
  }

  .info-table-section {
    padding: 0;
    border-bottom: 1px solid #ebeef5;

    .info-table {
      width: 100%;
      border-collapse: collapse;

      .info-row {
        border-bottom: 1px solid #ebeef5;

        &:last-child {
          border-bottom: none;
        }

        .info-label {
          width: 120px;
          padding: 14px 16px;
          font-size: 14px;
          color: #606266;
          font-weight: 500;
        }

        .info-value {
          padding: 14px 16px;
          font-size: 14px;
          color: #303133;
        }
      }
    }
  }

  .progress-section {
    padding: 20px;

    .progress-title {
      font-size: 16px;
      font-weight: 600;
      color: #303133;
      margin-bottom: 16px;
    }

    .progress-timeline {
      .progress-item {
        display: flex;
        align-items: flex-start;
        padding: 16px 0;
        position: relative;

        &:not(:last-child)::before {
          content: "";
          position: absolute;
          left: 9px;
          top: 40px;
          width: 2px;
          height: calc(100% - 16px);
          background: #ebeef5;
        }

        &.is-active .progress-dot {
          i {
            color: #1877ff;
          }
        }

        &.is-failed .progress-dot {
          i {
            color: #f56c6c;
          }
        }

        .progress-dot {
          width: 20px;
          height: 20px;
          margin-right: 12px;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .progress-content {
          flex: 1;

          .progress-text {
            font-size: 14px;
            color: #303133;
            margin-bottom: 6px;
            line-height: 1.5;
          }

          .progress-time {
            font-size: 12px;
            color: #999;
          }

          .progress-reason {
            font-size: 13px;
            color: #f56c6c;
            margin-top: 6px;
          }
        }
      }
    }
  }
}

// 账单详情抽屉样式
.bill-detail-drawer {
  padding: 0;

  .bill-amount-header {
    text-align: center;
    padding: 0 20px 18px;
    border-bottom: 1px solid #ebeef5;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .bill-amount-label {
      font-size: 16px;
      color: #303133;
      font-weight: 500;
    }

    .bill-amount-value {
      font-size: 32px;
      font-weight: 600;
      font-family: "DIN Alternate", "Arial", sans-serif;

      &.income {
        color: #ff6600;
      }

      &.expense {
        color: #ff3b30;
      }
    }
  }

  .bill-info-table-section {
    padding: 0;
    border-bottom: 1px solid #ebeef5;

    .bill-info-table {
      width: 100%;
      border-collapse: collapse;

      .bill-info-row {
        border-bottom: 1px solid #ebeef5;

        &:last-child {
          border-bottom: none;
        }

        .bill-info-label {
          width: 120px;
          padding: 14px 16px;
          font-size: 14px;
          color: #606266;
          font-weight: 500;
        }

        .bill-info-value {
          padding: 14px 16px;
          font-size: 14px;
          color: #303133;
        }
      }
    }
  }

  .bill-info-section {
    padding: 0;
  }
}
</style>
